import 'js-mq';
import Hammer from 'hammerjs';
import moment from 'moment';

//import values from 'core-js/fn/object/values';
//import assign from 'core-js/fn/object/assign';
//import entries from 'core-js/fn/object/entries';

var core = {
  /** Cherry-picked polyfills */
  Object: {
    values: Object.values,
    assign: Object.assign,
    entries: Object.entries
  }
};

var SYOSMisc = {

  BrowserSupportsCSSAnimations: false,

  checkBrowserCompatible: function checkBrowserCompatible() {
    // we used to test for Canvas and inline svg support here
    return true;
  },

  hexToRgb: function hexToRgb(hex) {
    if (hex.charAt(0) == '#') hex = hex.slice(1);
    var bigint = parseInt(hex, 16);
    var r = bigint >> 16 & 255;
    var g = bigint >> 8 & 255;
    var b = bigint & 255;

    return r + ',' + g + ',' + b;
  }

};

// http://stackoverflow.com/questions/149055/how-can-i-format-numbers-as-money-in-javascript
Number.prototype.toMoney = function (decimals, decimal_sep, thousands_sep) {
  var j;
  var n = this,
      c = isNaN(decimals) ? 2 : Math.abs(decimals),
      //if decimal is zero we must take it, it means user does not want to show any decimal
  d = decimal_sep || '.',
      //if no decimal separetor is passed we use the comma as default decimal separator (we MUST use a decimal separator)

  /*
   according to [http://stackoverflow.com/questions/411352/how-best-to-determine-if-an-argument-is-not-sent-to-the-javascript-function]
   the fastest way to check for not defined parameter is to use typeof value === 'undefined'
   rather than doing value === undefined.
   */
  t = typeof thousands_sep === 'undefined' ? ',' : thousands_sep,
      //if you don't want ot use a thousands separator you can pass empty string as thousands_sep value

  sign = n < 0 ? '-' : '',


  //extracting the absolute value of the integer part of the number and converting to string
  i = parseInt(n = Math.abs(n).toFixed(c), 10) + '',
      j = (j = i.length) > 3 ? j % 3 : 0;
  return sign + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '');
};

var SYOSEvents = {
  HOUSE_DATA_LOADED: "syos:houseDataLoaded",
  SUMMARY_DATA_LOAD_BEGIN: "syos:summaryDataLoadBegin",
  SUMMARY_DATA_LOADED: "syos:summaryDataLoaded",
  INFO_DATA_LOADED: "syos:infoDataLoaded",
  SYOS_READY: "syos:syosReady", // fired when house data, summary data, and info data loaded.
  SEAT_DATA_LOAD_BEGIN: "syos:seatDataLoadBegin",
  SEAT_DATA_LOADED: "syos:seatDataLoaded",
  CURR_FLOOR: "syos:currFloor",
  SEAT_ROLL_OVER: "syos:seatRollOver",
  SEAT_ROLL_OUT: "syos:seatRollOut",
  SEAT_CLICK: "syos:seatClick",
  ADD_SEAT_TO_CART: "syos:addSeatToCart",
  REMOVE_SEAT_FROM_CART: "syos:removeSeatFromCart",
  FLOOR_ROLL_OVER: "syos:floorRollOver",
  FLOOR_ROLL_OUT: "syos:floorRollOut",
  PHOTO_PREVIEW_TOGGLE: "syos:photoPreviewToggle",
  PHOTO_PREVIEW_CLICK: "syos:photoPreviewClick",
  VENUE_CHANGE: "syos:venueChange",
  SEAT_AVAIL_CHECK_BEGIN: "syos:seatAvailCheck",
  SEAT_AVAIL_CHECK_SUCCESS: "syos:seatAvailCheckSuccess",
  SEAT_AVAIL_CHECK_FAIL: "syos:seatAvailCheckFail",
  EXACT_TICKET_COUNT_MISMATCH: "syos:exactTicketCountMismatch",
  RESERVE_INVALID_GROUPED_TICKETS: "syos:reserveInvalidGroupedTickets",
  MAXIMUM_TICKET_COUNT_EXCEEDED: "syos:maximumTicketCountExceeded",
  MINIMUM_SEATS_FOR_PRICETYPES_NOT_ACQUIRED: "syos:minimumSeatsForPricetypesNotAcquired",
  CONFIRM_DIALOG_CLOSE: "syos:confirmDialogClose",
  DESTROY: "syos:destroy",

  RESIZE: "syos:resize",

  normalizeEvent: function normalizeEvent(event) {
    if (typeof event.clientX === 'undefined') {
      if (typeof event.pageX === 'undefined') {
        var changedTouches = event.changedTouches;
        var touches = event.touches;
        var touchList = changedTouches && changedTouches.length > 0 ? changedTouches : touches;
        var touch = touchList[0];

        event.clientX = touch.pageX - window.scrollX;
        event.clientY = touch.pageY - window.scrollY;
      } else {
        event.clientX = event.pageX - window.scrollX;
        event.clientY = event.pageY - window.scrollY;
      }
    }
  }
};

var SYOSMode = {
  STANDARD: 1,
  SEAT_PREVIEW: 2
};

var SYOSFloor = Class.create({

  // data           :: Object
  // summaryData    :: Object
  // docHandlers    :: Array

  // svgGroupElement    :: SVG G Element
  // mobileButton       :: Element
  // mouseOverCallback  :: Function
  // mouseOutCallback   :: Function
  // clickCallback      :: Function
  // touchStartCallback :: Function
  // touchEndCallback   :: Function
  // touchStartCoords   :: Object

  // mobileButtonClickHandler :: Event.Handler


  // mobile

  initialize: function initialize(syos, house, data, svgGroupElement) {

    this.syos = syos;
    this.data = data;

    this.numFrontLoadedSeats = 0;

    this.docHandlers = [document.on(SYOSEvents.CURR_FLOOR, this.doCurrFloor.bind(this)), document.on(SYOSEvents.SUMMARY_DATA_LOAD_BEGIN, this.doSummaryDataLoadBegin.bind(this)), document.on(SYOSEvents.SUMMARY_DATA_LOADED, this.doSummaryDataLoaded.bind(this))];

    this.mouseOverCallback = this.doMouseOver.bind(this);
    this.mouseOutCallback = this.doMouseOut.bind(this);
    this.clickCallback = this.doClick.bind(this);
    this.touchStartCallback = this.doTouchStart.bind(this);
    this.touchEndCallback = this.doTouchEnd.bind(this);

    if (svgGroupElement) {
      this.svgGroupElement = svgGroupElement;
      this.addSVGClassName(this.svgGroupElement, 'floor-' + this.data.floorNum);

      this.setAvailabilityClass();

      // this.setMobileButton(new Element('div'));
    }
  },

  addSVGClassName: function addSVGClassName(svgEl, className) {
    if (svgEl.classList) {
      svgEl.classList.add(className);
    } else {
      if (svgEl.getAttribute('class')) {
        svgEl.setAttribute('class', svgEl.getAttribute('class') + ' ' + className);
      } else {
        svgEl.setAttribute('class', className);
      }
    }
  },

  removeSVGClassName: function removeSVGClassName(svgEl, className) {
    if (svgEl.classList) {
      svgEl.classList.remove(className);
    } else if (svgEl.getAttribute('class')) {
      svgEl.setAttribute('class', svgEl.getAttribute('class').replace(new RegExp('(\\s|^)' + className + '(\\s|$)', 'g'), '$2'));
    }
  },

  doSummaryDataLoaded: function doSummaryDataLoaded(event) {
    this.setAvailabilityClass();
  },

  doSummaryDataLoadBegin: function doSummaryDataLoadBegin(event) {
    this.summaryData = null;
  },

  getPhotoPreviewData: function getPhotoPreviewData() {
    return this.data.photoPreviews || [];
  },

  getFloorName: function getFloorName() {
    return this.data.floorName || "";
  },

  getIsPannable: function getIsPannable() {
    return !!this.data.pannable;
  },

  doCurrFloor: function doCurrFloor(event) {
    if (SYOSFloor.currFloor) {
      this.disable();
    } else {
      this.enable();
    }
  },

  enable: function enable() {
    if (this.svgGroupElement) {
      this.svgGroupElement.addEventListener("mouseover", this.mouseOverCallback, false);
      this.svgGroupElement.addEventListener("mouseout", this.mouseOutCallback, false);
      this.svgGroupElement.addEventListener("click", this.clickCallback, false);
      this.svgGroupElement.addEventListener("touchstart", this.touchStartCallback, false);
      this.svgGroupElement.addEventListener("touchend", this.touchEndCallback, false);
      this.mobileButtonClickHandler.start();
    }
  },

  disable: function disable() {
    if (this.svgGroupElement) {
      this.svgGroupElement.removeEventListener("mouseover", this.mouseOverCallback, false);
      this.svgGroupElement.removeEventListener("mouseout", this.mouseOutCallback, false);
      this.svgGroupElement.removeEventListener("click", this.clickCallback, false);
      this.svgGroupElement.removeEventListener("touchstart", this.touchStartCallback, false);
      this.svgGroupElement.removeEventListener("touchend", this.touchEndCallback, false);
      this.mobileButtonClickHandler.stop();
    }
  },

  doMouseOver: function doMouseOver(event, element) {
    document.fire(SYOSEvents.FLOOR_ROLL_OVER, this);
  },
  doMouseOut: function doMouseOut(event, element) {
    document.fire(SYOSEvents.FLOOR_ROLL_OUT, this);
  },
  doClick: function doClick(event, element) {
    if (this.syos.mode === SYOSMode.SEAT_PREVIEW || this.syos.loadSoldOutFloors || this.getSummaryData().avail) {
      this.selectFloor();
    }
  },
  doTouchStart: function doTouchStart(event, element) {
    this.touchStartCoords = {
      x: event.changedTouches[0].screenX, y: event.changedTouches[0].screenY
    };
    document.fire(SYOSEvents.FLOOR_ROLL_OVER, this);
  },
  doTouchEnd: function doTouchEnd(event, element) {
    if ((this.syos.loadSoldOutFloors || this.getSummaryData().avail) && this.touchStartCoords) {
      if (this.touchStartCoords.x == event.changedTouches[0].screenX && this.touchStartCoords.y == event.changedTouches[0].screenY) {
        this.selectFloor();
      }
    }
  },
  selectFloor: function selectFloor() {
    SYOSFloor.currFloor = this;
    document.fire(SYOSEvents.CURR_FLOOR, this);
  },

  setSeatViewScalePerc: function setSeatViewScalePerc(value) {
    this.data.seatViewScalePerc = value;
  },
  setIndividualSeatScalePerc: function setIndividualSeatScalePerc(value) {
    this.data.individualSeatScalePerc = value;
  },
  setSeatViewOffset: function setSeatViewOffset(value) {
    this.data.seatViewOffset = value;
  },

  setMobileButton: function setMobileButton(mobileButton) {

    if (this.mobileButton) {
      this.disable();
      this.mobileButton.remove();
    }

    this.mobileButton = mobileButton;
    this.mobileButtonClickHandler = this.mobileButton.on('click', this.doClick.bind(this));
    this.enable();

    if (this.syos.mode !== SYOSMode.SEAT_PREVIEW) {
      if (!this.getSummaryData().avail) {
        mobileButton.addClassName('disabled');
      }
    }
  },

  setAvailabilityClass: function setAvailabilityClass() {

    if (this.syos.mode === SYOSMode.SEAT_PREVIEW) return;

    if (!this.svgGroupElement) return;

    if (this.getSummaryData().avail === 0) {
      this.addSVGClassName(this.svgGroupElement, 'sold-out');
    } else {
      this.removeSVGClassName(this.svgGroupElement, 'sold-out');
    }
  },

  getSeatViewScalePerc: function getSeatViewScalePerc() {
    return this.data.seatViewScalePerc || 1;
  },
  getSeatViewOffset: function getSeatViewOffset() {
    return this.data.seatViewOffset || { left: 0, top: 0 };
  },
  getIndividualSeatScalePerc: function getIndividualSeatScalePerc() {
    return this.data.individualSeatScalePerc || 1;
  },
  getSections: function getSections() {
    return this.data.secs;
  },
  getBgImgStyle: function getBgImgStyle() {

    if (this.data.bgImg) {

      return core.Object.assign(this.data.bgImg.style, {
        backgroundImage: "url('" + this.syos.houseDataBaseURL + "seatViewBackgrounds/" + this.data.bgImg.fileName + "')",
        display: "block"
      });
    } else {
      return { display: "none" };
    }
  },
  getSummaryData: function getSummaryData() {

    if (this.summaryData) {
      this.summaryData.numFrontLoadedSeats = this.numFrontLoadedSeats;
      return this.summaryData;
    }

    var summaryData = {
      floorName: this.getFloorName(),
      avail: 0,
      total: 0
    };

    var tmpZones = {};

    for (var i = this.data.secs.length - 1; i >= 0; i--) {
      var secNum = this.data.secs[i];
      var secData = null;
      try {
        secData = this.syos.summaryDataForSectionNum(secNum);
      } catch (e) {}

      if (secData === null) {
        continue;
      }

      summaryData.avail += secData.avail;
      summaryData.total += secData.total;

      for (var j = secData.zones.length - 1; j >= 0; j--) {
        var zoneData = secData.zones[j];
        var zoneId = zoneData.id;

        if (!tmpZones[zoneId]) {
          tmpZones[zoneId] = this.syos.summaryDataForZoneId(zoneId);
        }
      }
    }

    var tmpPricetypes = $H();
    $H(tmpZones).each(function (pair) {
      var thisZone = pair.value;

      for (var i = thisZone.pricetypes.length - 1; i >= 0; i--) {

        var thisZonePricetype = thisZone.pricetypes[i];

        var targetPricetype = tmpPricetypes.get(thisZonePricetype.id);

        if (!targetPricetype) {
          targetPricetype = core.Object.assign({ prices: [] }, this.syos.summaryDataForPricetypeId(thisZonePricetype.id));
          tmpPricetypes.set(thisZonePricetype.id, targetPricetype);
        }

        if (targetPricetype.prices.indexOf(thisZonePricetype.price) == -1) targetPricetype.prices.push(thisZonePricetype.price);
      }
    }, this);

    summaryData.pricetypes = tmpPricetypes.values().sortBy(function (pricetype) {
      return pricetype.order;
    });

    var sortByFunc = function sortByFunc(s) {
      return s;
    };

    for (i = summaryData.pricetypes.length - 1; i >= 0; i--) {
      var thisPricetype = summaryData.pricetypes[i];
      // thisPricetype.prices = thisPricetype.prices.sortBy(function(s) {
      // return s;
      // });
      thisPricetype.prices = thisPricetype.prices.sortBy(sortByFunc);
    }

    var pricetypeHTML = "",
        pricetypePriceHTML = "",
        pricetypeSummaryLabels = { "regular": [], "nfs-add-on": [] },
        pricetypeSummaryPrices = { "regular": [], "nfs-add-on": [] },
        addOnPricetypes = summaryData.pricetypes.filter(function (seatPricetype) {
      return !!seatPricetype.nfsAddOn;
    }),
        regPricetypes = summaryData.pricetypes.filter(function (seatPricetype) {
      return !seatPricetype.nfsAddOn;
    }),
        price;

    function addPricetypeLine(type, pricetypeData) {
      pricetypeHTML += pricetypeData.desc + "<br>";

      pricetypeSummaryLabels[type].push(pricetypeData.desc);

      if (pricetypeData.prices.length === 1) {
        price = "$" + pricetypeData.prices[0].toMoney();
      } else {
        price = "$" + pricetypeData.prices[0].toMoney() + " - $" + pricetypeData.prices[pricetypeData.prices.length - 1].toMoney();
      }

      pricetypeSummaryPrices[type].push(price);
      pricetypePriceHTML += price + "<br>";
    }
    regPricetypes.forEach(addPricetypeLine.curry("regular"), this);
    if (addOnPricetypes.length) {
      pricetypeHTML += new Element("div", { "class": "add-on-break" }).update("Extra Single Tickets").outerHTML;
      pricetypePriceHTML += new Element("div", { "class": "add-on-break" }).update("&nbsp;").outerHTML;
      addOnPricetypes.forEach(addPricetypeLine.curry("nfs-add-on"), this);
    }

    summaryData.pricetypeHTML = pricetypeHTML;
    summaryData.pricetypePriceHTML = pricetypePriceHTML;
    summaryData.pricetypeSummaryLabels = pricetypeSummaryLabels;
    summaryData.pricetypeSummaryPrices = pricetypeSummaryPrices;

    this.summaryData = summaryData;
    this.summaryData.numFrontLoadedSeats = this.numFrontLoadedSeats;

    return this.summaryData;
  },

  destroy: function destroy() {

    this.syos = null;

    this.docHandlers.invoke("stop");
    this.docHandlers = null;

    if (this.mobileButton) {
      this.mobileButton.remove();
      this.mobileButton = null;
    }

    this.disable();

    if (this.svgGroupElement) {
      this.svgGroupElement.parentNode.removeChild(this.svgGroupElement);
      this.svgGroupElement = null;
    }
  }

});

var SYOSMessage$$1 = {

  customProperties: {
    /*
    customFoo: function() {
      // now 'customFoo' can be used in a template string
      // customProperty functions are bound to SYOSMain.instance
      // 'sup bro, foo is {customFoo}'
      return 'bar';
    }
    */
  },

  applyTemplate: function applyTemplate(templateString, contextData) {

    var syos = SYOSMain.instance;
    if (syos) {

      /* We need to be defensive about each property. If an error occurs during SYOS initialization, some data may not be available. */
      var templateData = {
        exactTicketCountRequired: syos.summaryData ? syos.summaryData.requireExactTicketCountGlobal : undefined,
        maximumTicketCount: syos.summaryData ? syos.summaryData.maximumTicketCountGlobal : undefined,
        label: {
          seat: {
            totalSelected: syos.cart.getCartSeatsByPricetypeId() === 1 ? 'seat' : 'seats'
          }
        }
      };

      if (contextData) {
        templateData = core.Object.assign(templateData, contextData);
      }

      $H(SYOSMessage$$1.customProperties).each(function (pair) {
        templateData[pair.key] = pair.value.call(syos);
      }, this);

      return new Template(templateString).evaluate(templateData);
    } else {
      throw new Error('SYOSMessage.applyTemplate() requires a running instance of SYOSMain');
    }
  }
};

var SYOSMessageTemplates = {
  genericError: '<p>Sorry, an error occurred!</p><p>Please try again later or choose Best Available Seating.</p>',
  seatsNoLongerAvailable: 'The seats you attempted to add to your cart are no longer available.<br />Your selected seats have been reset.<br />Availability information is being refreshed.',
  incorrectExactTicketCount: 'You must choose exactly #{exactTicketCountRequired} #{label.seat.totalSelected} before adding to the cart.',
  incorrectTicketCountForPricetype: 'Minimum number of seats have not been met for one or more seat types.',
  maximumTicketCountExceeded: 'The maximum number of tickets you may reserve is #{maximumTicketCount}.',
  reserveInvalidGroupedTickets: '#{pricetypeName} seats must be reserved in #{labelRequiredIn} of #{groupedTickets}.<br><p><em>Currently #{currSelectedCount} selected.</em></p>',

  closeDialogWithUnreservedSeats_confirmClose: '<p>You have selected seats that have not been added to your cart.</p><p>Are you sure you want to cancel?<p>',
  closeDialogWithUnreservedSeats_reserveSeats: '<p>Would you like to add these seats to your cart before closing?<p>',

  labelFloorSoldOut: 'Sold Out'
};

var DisplayTypes = {
  STANDARD: 'standard',
  DONUT: 'donut',
  WHEELCHAIR: 'wheelchair',
  COMPANION: 'companion'
};

/**
 * Values here should match up w/ house.json config "seatHexCodes"
 */

var SYOSSeatRenderingState = {
  AVAILABLE: 'available',
  DISABLED: 'disabled',
  HOVER: 'hover',
  SAME_ZONE: 'sameZone',
  SAME_ZONE_DISABLED: 'sameZoneDisabled',
  SELECTED: 'selected'
};

function svgElFromString(xmlString) {
  if (window.DOMParser) {
    var domParser = new DOMParser();
    return domParser.parseFromString(xmlString, 'text/xml').documentElement;
  } else {
    var svgDoc = new ActiveXObject('Microsoft.XMLDOM');
    svgDoc.async = false;
    svgDoc.loadXML(xmlString);
    return svgDoc.documentElement;
  }
}

function imgElFromString(xmlString) {
  var img = new Image();
  var DOMURL = window.URL || window.webkitURL || window;
  var svg = new Blob([xmlString], { type: 'image/svg+xml' });
  var url = DOMURL.createObjectURL(svg);
  img.onload = function () {
    //DOMURL.revokeObjectURL(url);
  };
  img.src = url;
  return img;
}

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

















var set = function set(object, property, value, receiver) {
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent !== null) {
      set(parent, property, value, receiver);
    }
  } else if ("value" in desc && desc.writable) {
    desc.value = value;
  } else {
    var setter = desc.set;

    if (setter !== undefined) {
      setter.call(receiver, value);
    }
  }

  return value;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _defaultHexCodes;

var defaultHexCodes = (_defaultHexCodes = {}, defineProperty(_defaultHexCodes, SYOSSeatRenderingState.AVAILABLE, "#000000"), defineProperty(_defaultHexCodes, SYOSSeatRenderingState.DISABLED, "#EEEEEE"), defineProperty(_defaultHexCodes, SYOSSeatRenderingState.HOVER, "#0000FF"), defineProperty(_defaultHexCodes, SYOSSeatRenderingState.SAME_ZONE, "#109ee0"), defineProperty(_defaultHexCodes, SYOSSeatRenderingState.SAME_ZONE_DISABLED, "#EEEEEE"), defineProperty(_defaultHexCodes, SYOSSeatRenderingState.SELECTED, "#FF0000"), _defaultHexCodes);

var icons = {};

var iconSvgXml = {};
iconSvgXml[DisplayTypes.WHEELCHAIR] = '\n<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="-1 -1 52 52">\n  <circle cx="25" cy="25" r="25" fill="#000" />\n  <circle cx="25" cy="25" r="22" fill="white" />\n  <circle cx="25" cy="25" r="22" fill="#000" opacity=".15"/>\n  <path fill="#000" d="M22.57 14c1.42-.13 2.53-1.36 2.53-2.8.05-1.57-1.22-2.83-2.8-2.83-1.52 0-2.8 1.28-2.8 2.8 0 .5.15.98.37 1.4l1 14.1h10.3l4.23 9.94 5.57-2.2-.88-2.02L37 33.5l-4.1-9.47-9.6.07-.13-1.8h6.92v-2.64h-7.2L22.56 14z"/>\n  <path fill="#000" d="M32.94 34.26c-1.73 3.43-5.4 5.7-9.27 5.7-5.7 0-10.36-4.66-10.36-10.38 0-4.02 2.48-7.74 6.1-9.4l.2 3.07c-2.13 1.35-3.45 3.8-3.45 6.35 0 4.15 3.37 7.53 7.52 7.53 3.8 0 7.02-2.9 7.46-6.65l1.8 3.78z"/>\n</svg>';

iconSvgXml[DisplayTypes.COMPANION] = '\n<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="-1 -1 52 52">\n  <circle cx="25" cy="25" r="25" fill="#000" />\n  <circle cx="25" cy="25" r="22" fill="white" />\n  <circle cx="25" cy="25" r="22" fill="#000" opacity=".15"/>\n  <path fill="#000" d="M16.92 14.84c2.04-2.08 4.62-3.1 7.76-3.1 4.2 0 7.27 1.38 9.2 4.16 1.07 1.57 1.65 3.14 1.73 4.7h-5.25c-.35-1.2-.78-2.12-1.3-2.73-.93-1.1-2.33-1.6-4.16-1.6-1.9 0-3.38.78-4.47 2.33-1.08 1.55-1.62 3.74-1.62 6.55 0 2.85.58 4.96 1.73 6.35 1.14 1.43 2.6 2.13 4.36 2.13 1.8 0 3.17-.6 4.12-1.82.52-.63.96-1.6 1.3-2.9h5.24c-.45 2.75-1.6 4.96-3.48 6.7s-4.2 2.58-7.12 2.58c-3.57 0-6.4-1.16-8.45-3.48-2.05-2.35-3.07-5.55-3.07-9.62 0-4.4 1.16-7.8 3.5-10.18v-.06z"/>\n</svg>';

var iconsAvailable = core.Object.assign({}, iconSvgXml);

function updateIconStateColors() {
  var seatHexCodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var states = core.Object.assign({}, defaultHexCodes, seatHexCodes);
  var re = /(?:fill|stroke)="(#.+?)"/g;

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = core.Object.entries(iconSvgXml)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _step$value = slicedToArray(_step.value, 2),
          iconName = _step$value[0],
          svgXml = _step$value[1];

      svgXml = svgXml.trim();
      var iconStates = {};
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = core.Object.entries(states)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _step2$value = slicedToArray(_step2.value, 2),
              state = _step2$value[0],
              hexCode = _step2$value[1];

          var xml = void 0;
          if (state === SYOSSeatRenderingState.AVAILABLE) {
            xml = iconsAvailable[iconName];
          } else {
            xml = svgXml.replace(re, 'fill="' + hexCode + '"');
          }

          iconStates[state] = imgElFromString(xml);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      icons[iconName] = iconStates;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function getIconStateImagesForSeatDisplayType(displayType) {
  return icons[displayType];
}

function setAvailableSvgXmlForSeatDisplayType(displayType, svgXml) {
  iconsAvailable[displayType] = svgXml;
}

var SYOSSeatIcons = {
  updateIconStateColors: updateIconStateColors,
  getIconStateImagesForSeatDisplayType: getIconStateImagesForSeatDisplayType,
  setAvailableSvgXmlForSeatDisplayType: setAvailableSvgXmlForSeatDisplayType
};

var SYOSZoomControl = Class.create({

  // NOTE: Kind of a pain...
  // SYOSZoomControl operates on a scale from 0.0 - 1.0, whereas SYOSSeatView
  // spans SYOSSeatView.MIN_SCALE - SYOSSeatView.MAX_SCALE, so some conversion
  // is necessary.

  initialize: function initialize(syos, seatView) {

    this.syos = syos;
    this.seatView = seatView;

    var mainContainer = syos.getDisplayElement().down('#syos-zoom-control');

    this.elZoomIn = mainContainer.down('.zoom-in');
    this.elZoomOut = mainContainer.down('.zoom-out');
    this.elCurrPos = mainContainer.down('.curr-pos');
    this.elTrack = mainContainer.down('.track');

    /* Hardcoding these two measurements since:
       - They'll probably never change
       - Lots of hassle to measure these while 'hidden-phone' is in effect
    */
    this.trackHeight = 125 + 2; // height of the track + 2 (to exclude the scrubber's border)
    this.scrubberHeight = 27; // height of the scrubber

    this.zoomInEnabled = true;

    var hammerOptions = {
      drag: true,
      transform: false,
      drag_min_distance: 0,
      swipe: false,
      hold: false
    };

    this.elZoomIn.on('click', this.doZoomIn.bind(this));
    this.elZoomOut.on('click', this.doZoomOut.bind(this));
    this.elZoomIn.on('touchstart', this.doZoomIn.bind(this));
    this.elZoomOut.on('touchstart', this.doZoomOut.bind(this));

    this.hammer = Hammer(this.elCurrPos, hammerOptions);

    this.hammer.on('touch', this.onTouch.bind(this));
    this.hammer.on('drag', this.onDrag.bind(this));

    this.trackHammer = Hammer(this.elTrack, hammerOptions);

    this.trackHammer.on('touch', this.onTrackTouch.bind(this));
    this.trackHammer.on('drag', this.onDrag.bind(this));
  },

  doZoomIn: function doZoomIn(event) {
    event.preventDefault();
    this.seatView.animateToPerc(SYOSSeatView$$1.SCALE_PERC * 2);
  },
  doZoomOut: function doZoomOut(event) {
    event.preventDefault();
    this.seatView.animateToPerc(SYOSSeatView$$1.SCALE_PERC * 0.5);
  },

  // this should be the only function that actually updates SYOSZoomControl UI.
  // only called from SYOSSeatView
  setToPerc: function setToPerc(perc) {

    if (this.perc !== perc) {
      this.perc = perc;

      this.elCurrPos.setStyle({
        'top': this.trackHeight - Math.floor(this.trackHeight * perc) - this.scrubberHeight + perc * this.scrubberHeight + 'px'
      });

      if (this.perc === 1 && this.zoomInEnabled) {
        this.zoomInEnabled = false;
        this.elZoomIn.addClassName('disabled');
      } else if (!this.zoomInEnabled) {
        this.elZoomIn.removeClassName('disabled');
        this.zoomInEnabled = true;
      }

      if (this.perc === 0 && this.zoomOutEnabled) {
        this.zoomOutEnabled = false;
        this.elZoomOut.addClassName('disabled');
      } else if (!this.zoomOutEnabled) {
        this.elZoomOut.removeClassName('disabled');
        this.zoomOutEnabled = true;
      }
    }
  },

  onTrackTouch: function onTrackTouch(event) {

    event.gesture.preventDefault();
    SYOSEvents.normalizeEvent(event.gesture.srcEvent);

    // Event.offsetY is undefined in FF... see  http://www.jacklmoore.com/notes/mouse-position/
    var e = event.gesture.srcEvent;
    var target = e.target || e.srcElement;
    var rect = target.getBoundingClientRect();
    var offsetX = e.clientX - rect.left;
    var offsetY = e.clientY - rect.top;

    this.startingY = offsetY - Math.round(this.scrubberHeight * 0.5);

    var perc = 1 - this.startingY / (this.trackHeight - this.scrubberHeight);

    this.updateSeatView(perc, true);
  },

  onTouch: function onTouch(event) {
    this.startingY = parseInt(this.elCurrPos.getStyle('top'), 10);

    var perc = 1 - this.startingY / (this.trackHeight - this.scrubberHeight);

    this.updateSeatView(perc);
  },

  checkPerc: function checkPerc(perc) {
    return perc > 1 ? 1 : perc < 0 ? 0 : perc;
  },

  onDrag: function onDrag(event) {

    event.gesture.preventDefault();

    var perc = 1 - (this.startingY + event.gesture.deltaY) / (this.trackHeight - this.scrubberHeight);

    this.updateSeatView(perc);
  },

  updateSeatView: function updateSeatView(perc, animated) {
    this.seatView.cancelZoomAnimation();
    perc = this.checkPerc(perc);
    if (animated) {
      this.seatView.animateToPerc(this.checkPerc(perc) * SYOSSeatView$$1.MAX_SCALE);
    } else {
      this.seatView.updateSeatViewScaleToPerc(perc);
    }
  },

  destroy: function destroy() {
    this.syos = null;
    this.seatView = null;

    this.elZoomIn.purge();
    this.elZoomOut.purge();

    this.hammer.off('touch drag');
    this.hammer = null;

    this.trackHammer.off('touch drag');
    this.trackHammer = null;
  }
});

var SYOSOverlay = Class.create({

  // docHandlers       :: Array
  // mainContainer     :: Div Element
  // message           :: Div Element

  initialize: function initialize(syos, container) {

    this.syos = syos;

    if (container.tagName) {
      this.mainContainer = container;
    } else {
      this.mainContainer = syos.getDisplayElement().down(container);
    }

    this.docHandlers = [document.on(SYOSEvents.RESIZE, this.onResize.bind(this))];

    this.messageContainer = this.mainContainer.down('.message-container');
    this.message = this.mainContainer.down('.message');

    this.mainContainer.down('.overlay-background').setOpacity(0.9);
  },

  onResize: function onResize() {},

  show: function show() {
    // this.mainContainer.setOpacity(1);
    this.mainContainer.show();
  },
  hide: function hide() {
    // this.mainContainer.fade({duration: 0.2});
    this.mainContainer.hide();
  },
  hideQuickly: function hideQuickly() {
    this.mainContainer.hide();
  },

  getDisplayElement: function getDisplayElement() {
    return this.mainContainer;
  },

  destroy: function destroy() {

    this.syos = null;

    this.docHandlers.each(function (handler) {
      handler.stop();
    });
    this.docHandlers = null;
  }

});

var SYOSPhotoPreviewOverlay = Class.create(SYOSOverlay, {

  // image :: img Element

  initialize: function initialize($super, syos, photoPreview) {

    $super(syos, '#syos-photo-preview-overlay');

    this.imageContainer = this.mainContainer.down('.image-container');
    this.image = this.mainContainer.down('.photo-preview-image');
    this.closeButton = this.mainContainer.down('.close-button');
    this.closeButton.hide();

    this.resetDisplay();

    this.show();

    this.image.on('load', this.onImageLoaded.bind(this));
    this.image.writeAttribute('src', photoPreview.src);

    this.mainContainer.on('click', this.doClose.bind(this));

    this.syos.hideDialogCloseButton();
  },

  resetDisplay: function resetDisplay() {
    this.image.writeAttribute('src', '');
    this.imageContainer.hide();
    this.messageContainer.show();
  },

  onImageLoaded: function onImageLoaded(event) {
    this.messageContainer.fade({
      duration: 0.2,
      afterFinish: function () {
        this.imageContainer.setOpacity(0).show();
        this.imageContainer.appear({ duration: 0.2 });
      }.bind(this)
    });
  },

  doClose: function doClose(event) {

    this.syos.showDialogCloseButton();

    this.mainContainer.fade({
      duration: 0.2,
      afterFinish: function () {
        this.image.purge();
        this.hide();
        this.mainContainer.purge();
        this.destroy();
      }.bind(this)
    });
  }
});

var SYOSSeatView$$1 = Class.create({

  // seatViewMainContainer           :: Div Element

  // docHandlers                     :: Array
  // seats                           :: Array

  // hammer                          :: Hammer
  // canvasOffset                    :: Element.Offset {left: int, top: int}
  // dragModifier                    :: Object {x:int, y:int}
  // currDraggingModifier            :: Object {x:int, y:int}
  // transformCenterPoint            :: Object {x:int, y:int}
  // transformStartCenterPoint       :: Object {x:int, y:int};
  // transformStartScale             :: Number

  // allSeatsMode                    :: Bool
  // seatViewInitialized             :: Bool
  // didTransform                    :: Bool

  // mouseMoveHandler                :: Event.Handler
  // prevMouseMoveEvent              :: Event
  // prevPinchEvent                  :: Event

  // currHoveringItem                :: Object {data: Object, type: SYOSSeatView.HOVER_TYPE_XXX}

  initialize: function initialize(syos, cart, pricetypeSelector, legend, options) {

    SYOSSeatView$$1.instance = this;

    this.syos = syos;
    this.cart = cart;
    this.legend = legend;
    this.allSeatsMode = !!options.allSeatsMode || this.syos.mode === SYOSMode.SEAT_PREVIEW;
    this.highlightSamePriceConfig = !!options.highlightSamePrice;
    this.alwaysHighlightSamePrice = !!options.alwaysHighlightSamePrice;

    this.seatViewMainContainer = syos.getDisplayElement().down('#syos-seat-view');
    this.canvas = syos.getDisplayElement().down('#syos-canvas');
    this.ctx = this.canvas.getContext('2d');

    this.photoPlotImage = new Element('img', { src: SYOSSeatView$$1.PHOTO_PLOT_SRC });

    this.zoomControl = new SYOSZoomControl(syos, this);

    this.seatViewMainContainer.setOpacity(0);

    this.docHandlers = [document.on(SYOSEvents.CURR_FLOOR, this.doCurrFloor.bind(this)), document.on(SYOSEvents.RESIZE, this.onResize.bind(this)), document.on(SYOSEvents.ADD_SEAT_TO_CART, this.clearCurrHoveringItem.bind(this)), document.on(SYOSEvents.REMOVE_SEAT_FROM_CART, this.clearCurrHoveringItem.bind(this)), document.on(SYOSEvents.PHOTO_PREVIEW_TOGGLE, this.doPhotoPreviewToggle.bind(this)), document.on(SYOSEvents.SUMMARY_DATA_LOAD_BEGIN, this.doSummaryDataLoadBegin.bind(this))];

    this.hammer = Hammer(this.canvas, {
      drag_min_distance: 0,
      swipe: false,
      hold: false,
      transform: true,
      transform_always_block: true
    });

    this.mouseMoveHandler = this.canvas.on('mousemove', this.onMouseMove.bind(this));
    this.canvas.on('mouseleave', this.clearCurrHoveringItem.bind(this));

    this.canvas.on('mousewheel', this.onMouseWheel.bind(this));
    this.canvas.on("DOMMouseScroll", this.onMouseWheel.bind(this));

    this.canvas.on('mousedown', this.onMouseDown.bind(this));
    this.canvas.on('touchstart', this.onTouchStart.bind(this));

    this.hammer.on('touch', this.onHammerTouch.bind(this));
    this.hammer.on('release', this.onHammerRelease.bind(this));
    this.hammer.on('dragstart', this.onHammerDragStart.bind(this));
    this.hammer.on('drag', this.onHammerDrag.bind(this));
    this.hammer.on('dragend', this.onHammerDragEnd.bind(this));
    this.hammer.on('tap', this.onHammerTap.bind(this));
    this.hammer.on('doubletap', this.onHammerDoubleTap.bind(this));
    this.hammer.on('transformstart', this.onHammerTransformStart.bind(this));
    this.hammer.on('transformend', this.onHammerTransformEnd.bind(this));
    this.hammer.on('pinch', this.onHammerPinch.bind(this));
  },

  doSummaryDataLoadBegin: function doSummaryDataLoadBegin(event) {},

  doPhotoPreviewToggle: function doPhotoPreviewToggle(event) {
    this.photoPreviewActive = event.memo.isActive;
    this.renderAll();
  },

  clearCurrHoveringItem: function clearCurrHoveringItem() {

    if (!this.readyToRender) {
      return;
    }

    if (this.currHoveringItem) {
      var type = this.currHoveringItem.type;
      this.currHoveringItem = null;
      this.currHoveringItemType = null;
      if (type === SYOSSeatView$$1.HOVER_TYPE_SEAT) {
        document.fire(SYOSEvents.SEAT_ROLL_OUT);
      }
    }
    this.renderAll();
  },

  showPhotoPreview: function showPhotoPreview(photoPreview) {
    if (SYOSMain.testIsMobileView()) {
      window.open(photoPreview.src, '_blank');
    } else {
      new SYOSPhotoPreviewOverlay(this.syos, photoPreview);
    }
  },

  onHammerTouch: function onHammerTouch(event) {
    this.mouseMoveHandler.stop();
  },
  onHammerRelease: function onHammerRelease(event) {
    this.mouseMoveHandler.start();
    this.didTransform = false;
  },
  onHammerDragStart: function onHammerDragStart(event) {
    event.gesture.preventDefault();
    if (this.didTransform) return;

    this.clearCurrHoveringItem();
    this.cancelZoomAnimation();
  },

  onHammerDrag: function onHammerDrag(event) {
    event.gesture.preventDefault();
    if (this.didTransform) return;

    this.currDraggingModifier.x = this.dragModifier.x + event.gesture.deltaX;
    this.currDraggingModifier.y = this.dragModifier.y + event.gesture.deltaY;
    this.renderAll();
  },

  onHammerDragEnd: function onHammerDragEnd(event) {
    event.gesture.preventDefault();
    if (this.didTransform) return;

    this.dragModifier.x += event.gesture.deltaX;
    this.dragModifier.y += event.gesture.deltaY;
  },
  onHammerTap: function onHammerTap(event) {
    event.gesture.preventDefault();

    if (this.syos.mode === SYOSMode.SEAT_PREVIEW) {
      return;
    }

    var point = this.localPointForEvent(event.gesture.srcEvent);
    if (this.photoPreviewActive) {
      var clickedPlot = this.photoPlotForEvent(event.gesture.srcEvent, point);
      if (clickedPlot) {
        this.showPhotoPreview(clickedPlot);
        return;
      }
    }

    var clickedSeat = this.seatForEvent(event.gesture.srcEvent, point);
    if (clickedSeat) {
      clickedSeat.doClick(event);
      this.clearCurrHoveringItem();
    }
  },

  onHammerDoubleTap: function onHammerDoubleTap(event) {
    event.gesture.preventDefault();

    // if (event.gesture.pointerType === 'mouse') return;
    if (SYOSSeatView$$1.SCALE_PERC === SYOSSeatView$$1.MAX_SCALE) return;
    if (this.currHoveringItem) return;

    this.cancelZoomAnimation();

    var finalPerc = SYOSSeatView$$1.SCALE_PERC * 2;

    this.animateToPercAroundCenterPoint(finalPerc, event.gesture.center.pageX - (window.scrollX || document.documentElement.scrollLeft || 0), event.gesture.center.pageY - (window.scrollY || document.documentElement.scrollTop || 0));
  },

  animateToPerc: function animateToPerc(perc) {
    this.animateToPercAroundCenterPoint(perc, this.canvasOffset.left + SYOSMain.STAGE_WIDTH * 0.5, this.canvasOffset.top + SYOSMain.STAGE_HEIGHT * 0.5);
  },

  animateToPercAroundCenterPoint: function animateToPercAroundCenterPoint(perc, centerPointX, centerPointY) {
    if (perc === SYOSSeatView$$1.SCALE_PERC) return;

    perc = perc > SYOSSeatView$$1.MAX_SCALE ? SYOSSeatView$$1.MAX_SCALE : perc < SYOSSeatView$$1.MIN_SCALE ? SYOSSeatView$$1.MIN_SCALE : perc;

    this.transformCenterPoint.x = centerPointX;
    this.transformCenterPoint.y = centerPointY;

    this.zoomAnimation = new Effect.Tween(null, SYOSSeatView$$1.SCALE_PERC, perc, {
      duration: 0.5,
      fps: 30
    }, function (perc) {
      this.updateSeatViewScaleByPerc(perc / SYOSSeatView$$1.SCALE_PERC);
    }.bind(this));
  },

  onHammerTransformStart: function onHammerTransformStart(event) {
    event.gesture.preventDefault();

    this.didTransform = true;
    this.transformStartScale = SYOSSeatView$$1.SCALE_PERC;

    this.transformCenterPoint.x = this.transformStartCenterPoint.x = event.gesture.center.pageX;
    this.transformCenterPoint.y = this.transformStartCenterPoint.y = event.gesture.center.pageY;

    this.renderAll();
  },

  onHammerTransformEnd: function onHammerTransformEnd(event) {
    event.gesture.preventDefault();

    // In the case where the user pinched, then removed their fingers one at a time,
    // this event gets fired from the 2nd solitary finger removing. Switch to the
    // `prevPinchEvent` which does contain two touches, and thus a good center point
    if (event.gesture.touches.length === 1) {
      event = this.prevPinchEvent;
    }

    this.dragModifier.x += event.gesture.center.pageX - this.transformStartCenterPoint.x;
    this.dragModifier.y += event.gesture.center.pageY - this.transformStartCenterPoint.y;

    this.renderAll();
  },

  onHammerPinch: function onHammerPinch(event) {
    event.gesture.preventDefault();

    this.prevPinchEvent = event;

    this.transformCenterPoint.x = event.gesture.center.pageX;
    this.transformCenterPoint.y = event.gesture.center.pageY;

    this.currDraggingModifier.x = this.dragModifier.x + event.gesture.center.pageX - this.transformStartCenterPoint.x;
    this.currDraggingModifier.y = this.dragModifier.y + event.gesture.center.pageY - this.transformStartCenterPoint.y;

    this.updateSeatViewScaleByPerc(event.gesture.scale * this.transformStartScale / SYOSSeatView$$1.SCALE_PERC);
  },

  positionedOffsetForSeat: function positionedOffsetForSeat(seat) {

    var left = Math.round(this.canvasOffset.left + this.dragModifier.x + seat.x * SYOSSeatView$$1.SCALE_PERC + SYOSSeat$$1.HALF_WIDTH - SYOSMain.VIEWPORT_OFFSET.left);
    var top = Math.round(this.canvasOffset.top + this.dragModifier.y + seat.y * SYOSSeatView$$1.SCALE_PERC + SYOSSeat$$1.HALF_WIDTH - SYOSMain.VIEWPORT_OFFSET.top);
    return {
      left: left,
      top: top
    };
  },

  photoPlotForEvent: function photoPlotForEvent(event, point) {

    if (!this.photoPreviewData || !this.photoPreviewData.length) return null;

    if (!point) point = this.localPointForEvent(event);

    var selectedPhotoPlot = null;

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = this.photoPreviewData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var photoPreview = _step.value;

        if (Math.pow(point.x - photoPreview.x * SYOSSeatView$$1.SCALE_PERC, 2) + Math.pow(point.y - photoPreview.y * SYOSSeatView$$1.SCALE_PERC, 2) < Math.pow(SYOSSeatView$$1.PHOTO_PLOT_HALF_WIDTH, 2)) {
          selectedPhotoPlot = photoPreview;
          break;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return selectedPhotoPlot;
  },

  localPointForEvent: function localPointForEvent(event) {

    SYOSEvents.normalizeEvent(event);

    var clientX = event.clientX;
    var clientY = event.clientY;

    if (clientX === 0 && clientY === 0 && event.touches.length) {
      clientX = event.touches[0].clientX;
      clientY = event.touches[0].clientY;
    }

    return {
      x: clientX - this.canvasOffset.left - this.dragModifier.x,
      y: clientY - this.canvasOffset.top - this.dragModifier.y
    };
  },

  seatForEvent: function seatForEvent(event, point) {

    if (!this.seats || !this.seats.length) return null;

    if (!point) point = this.localPointForEvent(event);

    var selectedSeat = null;

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = this.seats[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var seat = _step2.value;

        if (seat.isAvailable && Math.pow(point.x - SYOSSeat$$1.HALF_WIDTH - seat.x * SYOSSeatView$$1.SCALE_PERC, 2) + Math.pow(point.y - SYOSSeat$$1.HALF_WIDTH - seat.y * SYOSSeatView$$1.SCALE_PERC, 2) < Math.pow(SYOSSeat$$1.HALF_WIDTH, 2)) {
          selectedSeat = seat;
          break;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return selectedSeat;
  },

  getCurrHoveringItemForEvent: function getCurrHoveringItemForEvent(event) {
    var hoverItem = null;
    var point = this.localPointForEvent(event);

    if (this.photoPreviewActive) {
      hoverItem = this.photoPlotForEvent(event, point);
      if (hoverItem) {
        return {
          data: hoverItem,
          type: SYOSSeatView$$1.HOVER_TYPE_PHOTO_PLOT
        };
      }
    }

    hoverItem = this.seatForEvent(event, point);
    if (hoverItem) {
      return {
        data: hoverItem,
        type: SYOSSeatView$$1.HOVER_TYPE_SEAT
      };
    }

    return null;
  },

  onMouseMove: function onMouseMove(event) {
    event.preventDefault();

    // I want to do this because changing the cursor to/from default/pointer triggers a mousemove event.
    // Check the coords to see if movement actually occured.
    if (this.prevMouseMoveEvent && (this.prevMouseMoveEvent.pageX !== event.pageX || this.prevMouseMoveEvent.pageY !== event.pageY)) {

      var hoveringItem = this.getCurrHoveringItemForEvent(event);

      if (hoveringItem) {

        if (this.currHoveringItem && hoveringItem.data != this.currHoveringItem.data) {
          this.clearCurrHoveringItem();
        }

        this.currHoveringItem = hoveringItem;
        this.renderAll();

        if (this.currHoveringItem.type === SYOSSeatView$$1.HOVER_TYPE_SEAT) {
          document.fire(SYOSEvents.SEAT_ROLL_OVER, this.currHoveringItem.data);
        }
      } else if (this.currHoveringItem) {
        this.clearCurrHoveringItem();
      }
    }

    this.prevMouseMoveEvent = event;

    if (SYOSSeatView$$1.SHOW_LOCAL_COORDS === true) {
      var point = this.localPointForEvent(this.prevMouseMoveEvent);

      this.ctx.beginPath();
      this.ctx.fillStyle = SYOSSeatView$$1.BLACK;
      this.ctx.fillRect(30, SYOSMain.STAGE_HEIGHT - 80, 100, 30);
      this.ctx.closePath();

      this.ctx.clearRect(31, SYOSMain.STAGE_HEIGHT - 79, 98, 28);

      this.ctx.fillStyle = SYOSSeatView$$1.BOUNDS_FILL;
      this.ctx.font = SYOSSeatView$$1.CANVAS_FONT;
      this.ctx.fillText(Math.round(point.x / SYOSSeatView$$1.SCALE_PERC) + ', ' + Math.round(point.y / SYOSSeatView$$1.SCALE_PERC), 50, SYOSMain.STAGE_HEIGHT - 60);
    }
  },

  onMouseWheel: function onMouseWheel(event) {
    event.preventDefault();
    SYOSEvents.normalizeEvent(event);

    var delta = Math.max(-1, Math.min(1, event.wheelDelta || -event.detail));

    this.clearCurrHoveringItem();

    this.transformCenterPoint.x = event.clientX;
    this.transformCenterPoint.y = event.clientY;

    if (delta < 0) {
      this.updateSeatViewScaleByPerc(0.95);
    } else {
      this.updateSeatViewScaleByPerc(1.05);
    }
  },
  onMouseDown: function onMouseDown(event) {
    this.transformCenterPoint.x = event.pageX;
    this.transformCenterPoint.y = event.pageY;
  },
  onTouchStart: function onTouchStart(event) {
    event.preventDefault(); // don't want touches to trigger mouse events
  },

  onResize: function onResize() {

    if (!SYOSFloor.currFloor) return;
    if (!this.seats) return;
    if (!this.bounds) return;

    var bounds = this.getScaledBounds();
    var horiPerc = void 0;
    var vertOffset = void 0;
    var vertPerc = void 0;

    var padding = this.getCurrentPadding();
    var cartHeaderHeight = this.cart.getHeaderHeight();
    var canvasWidth = SYOSMain.STAGE_WIDTH;
    var canvasHeight = SYOSMain.STAGE_HEIGHT - cartHeaderHeight;
    var dpr = window.devicePixelRatio || 1;

    this.canvasOffset = this.canvas.cumulativeOffset();

    if (this.seatViewInitialized) {

      horiPerc = (this.dragModifier.x + bounds.width * 0.5) / SYOSMain.PREV_STAGE_WIDTH;

      if (bounds.height <= SYOSMain.STAGE_HEIGHT) {
        vertPerc = (this.dragModifier.y + bounds.height * 0.5) / SYOSMain.PREV_STAGE_HEIGHT;
      } else {
        vertOffset = bounds.height + this.dragModifier.y - SYOSMain.PREV_STAGE_HEIGHT;
      }
    }

    this.canvas.setAttribute('width', canvasWidth * dpr);
    this.canvas.setAttribute('height', canvasHeight * dpr);
    this.canvas.setStyle({
      width: canvasWidth + 'px',
      height: canvasHeight + 'px',
      paddingBottom: cartHeaderHeight + 'px'
    });

    this.ctx.scale(dpr, dpr);

    if (!this.seatViewInitialized) {

      var targetWidth = SYOSMain.STAGE_WIDTH - padding.left - padding.right;
      var targetHeight = SYOSMain.STAGE_HEIGHT - padding.bottom - padding.top - cartHeaderHeight;
      var fillingWidthPerc = targetWidth / bounds.width;
      var fillingHeightPerc = targetHeight / bounds.height;

      if (fillingWidthPerc >= SYOSSeatView$$1.SCALE_PERC && fillingHeightPerc >= SYOSSeatView$$1.SCALE_PERC) {
        // no scaling needed, we fit into view
      } else if (fillingWidthPerc <= fillingHeightPerc) {
        // we're wider than we are taller, need to scale so we fit horizontally
        this.updateSeatViewScaleByPerc(fillingWidthPerc, false);
      } else {
        // we're taller - need to scale so we fit vertically
        this.updateSeatViewScaleByPerc(fillingHeightPerc, false);
      }

      this.centerSeatView();
      this.seatViewInitialized = true;
    } else {

      this.dragModifier.x = Math.round(SYOSMain.STAGE_WIDTH * horiPerc - bounds.width * 0.5);

      if (vertPerc) {
        this.dragModifier.y = Math.round(SYOSMain.STAGE_HEIGHT * vertPerc - bounds.height * 0.5);
      } else {
        this.dragModifier.y = SYOSMain.STAGE_HEIGHT + vertOffset - bounds.height;
      }
    }

    this.currDraggingModifier.x = this.dragModifier.x;
    this.currDraggingModifier.y = this.dragModifier.y;

    this.renderAll();
  },

  getCurrentPadding: function getCurrentPadding() {
    if (SYOSMain.testIsMobileView()) {
      return {
        top: 0,
        right: 25,
        bottom: 25,
        left: 25
      };
    } else {
      return SYOSSeatView$$1.Padding;
    }
  },

  centerSeatView: function centerSeatView() {

    var bounds = this.getScaledBounds();
    var padding = this.getCurrentPadding();
    var cartHeaderHeight = this.cart.getHeaderHeight();

    if (bounds.width > SYOSMain.STAGE_WIDTH) {
      this.dragModifier.x = -Math.round((bounds.width - SYOSMain.STAGE_WIDTH) * 0.5);
    } else {
      this.dragModifier.x = Math.round((SYOSMain.STAGE_WIDTH - bounds.width) * 0.5);
    }

    if (bounds.height + (padding.bottom > padding.top ? padding.bottom : padding.top) * 2 < SYOSMain.STAGE_HEIGHT - cartHeaderHeight) {
      this.dragModifier.y = Math.round((SYOSMain.STAGE_HEIGHT - cartHeaderHeight - bounds.height) * 0.5);
    } else {
      this.dragModifier.y = Math.round(SYOSMain.STAGE_HEIGHT - cartHeaderHeight - bounds.height - padding.bottom);
    }
  },

  renderAll: function renderAll() {

    var offset = this.currDraggingModifier;
    var currBounds = this.getScaledBounds();
    var dragModifier = this.dragModifier;
    var ctx = this.ctx;
    var canvasOffset = this.canvasOffset;
    var prevBounds = void 0;
    var percentageOfImageAtPinchPointX = void 0;
    var percentageOfImageAtPinchPointY = void 0;
    var translateFromZoomingX = void 0;
    var translateFromZoomingY = void 0;
    var translateTotalX = void 0;
    var translateTotalY = void 0;
    var currHoveringSeat = null;
    var currHoveringPhotoPlot = null;

    if (this.currHoveringItem) {
      if (this.currHoveringItem.type === SYOSSeatView$$1.HOVER_TYPE_SEAT) {
        if (this.syos.mode !== SYOSMode.SEAT_PREVIEW) {
          currHoveringSeat = this.currHoveringItem.data;
        }
      } else {
        currHoveringPhotoPlot = this.currHoveringItem.data;
      }
    }

    ctx.clearRect(0, 0, SYOSMain.STAGE_WIDTH, SYOSMain.STAGE_HEIGHT);

    if (!this.readyToRender) return;

    if (SYOSSeatView$$1.PREV_SCALE_PERC !== SYOSSeatView$$1.SCALE_PERC) {

      prevBounds = this.getScaledBounds(SYOSSeatView$$1.PREV_SCALE_PERC);

      percentageOfImageAtPinchPointX = (this.transformCenterPoint.x - canvasOffset.left - offset.x) / prevBounds.width;
      percentageOfImageAtPinchPointY = (this.transformCenterPoint.y - canvasOffset.top - offset.y) / prevBounds.height;

      translateFromZoomingX = Math.round((prevBounds.width - currBounds.width) * percentageOfImageAtPinchPointX);
      translateFromZoomingY = Math.round((prevBounds.height - currBounds.height) * percentageOfImageAtPinchPointY);

      translateTotalX = translateFromZoomingX + offset.x;
      translateTotalY = translateFromZoomingY + offset.y;

      offset.x = translateTotalX;
      offset.y = translateTotalY;

      dragModifier.x += translateFromZoomingX;
      dragModifier.y += translateFromZoomingY;
    }

    // Restraints:
    if (offset.x > SYOSMain.STAGE_WIDTH - SYOSSeatView$$1.MARGIN) {
      offset.x = SYOSMain.STAGE_WIDTH - SYOSSeatView$$1.MARGIN;
      dragModifier.x = offset.x;
    } else if (offset.x + currBounds.width < SYOSSeatView$$1.MARGIN) {
      offset.x = SYOSSeatView$$1.MARGIN - currBounds.width;
      dragModifier.x = offset.x;
    }

    var maxY = SYOSMain.STAGE_HEIGHT - this.cart.getHeaderHeight() - SYOSSeatView$$1.MARGIN;

    if (currBounds.height + offset.y < SYOSSeatView$$1.MARGIN) {
      offset.y = -currBounds.height + SYOSSeatView$$1.MARGIN;
      dragModifier.y = offset.y;
    } else if (offset.y > maxY) {
      offset.y = maxY;
      dragModifier.y = offset.y;
    }

    if (SYOSSeatView$$1.DRAW_MARGIN) {
      ctx.beginPath();
      ctx.fillStyle = SYOSSeatView$$1.MARGIN_FILL;
      ctx.fillRect(SYOSSeatView$$1.MARGIN, SYOSSeatView$$1.MARGIN, SYOSMain.STAGE_WIDTH - SYOSSeatView$$1.MARGIN * 2, maxY - SYOSSeatView$$1.MARGIN);
      ctx.closePath();
    }

    if (this.backgroundImage && this.backgroundData.naturalWidth) {
      ctx.drawImage(this.backgroundImage, offset.x + this.backgroundData.x * SYOSSeatView$$1.SCALE_PERC * this.backgroundData.scaleMod, offset.y + this.backgroundData.y * SYOSSeatView$$1.SCALE_PERC * this.backgroundData.scaleMod, this.backgroundData.naturalWidth * SYOSSeatView$$1.SCALE_PERC * this.backgroundData.scaleMod, this.backgroundData.naturalHeight * SYOSSeatView$$1.SCALE_PERC * this.backgroundData.scaleMod);
    }

    var drawnSeats = 0;
    var color = void 0;
    /** @type SYOSSeat **/
    var seat = void 0;
    var x = void 0;
    var y = void 0;
    var x1 = void 0;
    var y1 = void 0;
    var x2 = void 0;
    var y2 = void 0;
    var i = void 0;
    var len = this.seats.length;

    for (i = 0; i < len; i++) {

      seat = this.seats[i];

      x = seat.x * SYOSSeatView$$1.SCALE_PERC + offset.x + SYOSSeat$$1.HALF_WIDTH;
      y = seat.y * SYOSSeatView$$1.SCALE_PERC + offset.y + SYOSSeat$$1.HALF_WIDTH;

      x1 = x - SYOSSeat$$1.WIDTH;
      y1 = y - SYOSSeat$$1.WIDTH;
      x2 = x + SYOSSeat$$1.WIDTH;
      y2 = y + SYOSSeat$$1.WIDTH;

      if (
      // true ||
      0 <= x1 && x1 <= SYOSMain.STAGE_WIDTH && 0 <= y1 && y1 <= SYOSMain.STAGE_HEIGHT || 0 <= x2 && x2 <= SYOSMain.STAGE_WIDTH && 0 <= y1 && y1 <= SYOSMain.STAGE_HEIGHT || 0 <= x1 && x1 <= SYOSMain.STAGE_WIDTH && 0 <= y2 && y2 <= SYOSMain.STAGE_HEIGHT || 0 <= x2 && x2 <= SYOSMain.STAGE_WIDTH && 0 <= y2 && y2 <= SYOSMain.STAGE_HEIGHT) {

        drawnSeats++;

        // "state" is for icons, "color" is for circles. This is a mess, sorry!
        var state = null;
        var _color = seat.hex;

        if (seat.selectedPricetype) {

          _color = SYOSSeat$$1.COLOR_SELECTED;
          state = SYOSSeatRenderingState.SELECTED;
        } else if (currHoveringSeat) {

          if (seat === currHoveringSeat) {

            _color = SYOSSeat$$1.COLOR_HOVER;
            state = SYOSSeatRenderingState.HOVER;
          } else if (this.highlightSamePrice && currHoveringSeat.comparePrice === seat.comparePrice) {

            if (seat.isAvailable) {
              _color = SYOSSeat$$1.COLOR_SAME_ZONE;
              state = SYOSSeatRenderingState.SAME_ZONE;
            } else {
              _color = SYOSSeat$$1.COLOR_SAME_ZONE_DISABLED;
              state = SYOSSeatRenderingState.SAME_ZONE_DISABLED;
            }
          }
        }

        seat.render(ctx, x, y, state, _color);
      }
    }

    if (SYOSSeatView$$1.DRAW_BOUNDS) {
      ctx.beginPath();
      ctx.fillStyle = SYOSSeatView$$1.BOUNDS_FILL;
      ctx.fillRect(currBounds.x + offset.x, currBounds.y + offset.y, currBounds.width, currBounds.height);
      ctx.closePath();
    }

    if (SYOSSeatView$$1.DRAW_SCALE_PERC === true) {
      ctx.fillStyle = SYOSSeatView$$1.BOUNDS_FILL;
      ctx.font = SYOSSeatView$$1.CANVAS_FONT;
      ctx.fillText(SYOSSeatView$$1.SCALE_PERC, 10, SYOSMain.STAGE_HEIGHT - 100);
    }

    if (this.photoPreviewActive === true) {
      for (i = 0, len = this.photoPreviewData.length; i < len; i++) {
        var photoPreview = this.photoPreviewData[i];
        ctx.drawImage(this.photoPlotImage, Math.floor(photoPreview.x * SYOSSeatView$$1.SCALE_PERC + offset.x - SYOSSeatView$$1.PHOTO_PLOT_HALF_WIDTH), Math.floor(photoPreview.y * SYOSSeatView$$1.SCALE_PERC + offset.y - SYOSSeatView$$1.PHOTO_PLOT_HALF_WIDTH));
      }
    }

    if (this.currHoveringItem) {
      if (this.syos.mode === SYOSMode.SEAT_PREVIEW) {
        this.canvas.style.cursor = SYOSSeatView$$1.CURSOR_DEFAULT;
      } else {
        this.canvas.style.cursor = SYOSSeatView$$1.CURSOR_POINTER;
      }
    } else {
      this.canvas.style.cursor = SYOSSeatView$$1.CURSOR_MOVE;
    }
  },

  updateSeatViewScaleToPerc: function updateSeatViewScaleToPerc(perc) {
    SYOSSeatView$$1.SCALE_PERC = (SYOSSeatView$$1.MAX_SCALE - SYOSSeatView$$1.MIN_SCALE) * perc + SYOSSeatView$$1.MIN_SCALE;

    var x = this.canvasOffset.left + SYOSMain.STAGE_WIDTH * 0.5;
    var y = this.canvasOffset.top + SYOSMain.STAGE_HEIGHT * 0.5;
    this.transformCenterPoint = { x: x, y: y };

    if (SYOSSeatView$$1.SCALE_PERC < SYOSSeatView$$1.MIN_SCALE) {
      SYOSSeatView$$1.SCALE_PERC = SYOSSeatView$$1.MIN_SCALE;
    } else if (SYOSSeatView$$1.SCALE_PERC > SYOSSeatView$$1.MAX_SCALE) {
      SYOSSeatView$$1.SCALE_PERC = SYOSSeatView$$1.MAX_SCALE;
    }

    SYOSSeat$$1.WIDTH = this.bounds.width * SYOSSeatView$$1.SCALE_PERC * SYOSSeat$$1.WIDTH_RATIO;
    SYOSSeat$$1.HALF_WIDTH = SYOSSeat$$1.WIDTH * 0.5;

    this.renderAll();

    this.zoomControl.setToPerc(perc);

    SYOSSeatView$$1.PREV_SCALE_PERC = SYOSSeatView$$1.SCALE_PERC;
  },

  updateSeatViewScaleByPerc: function updateSeatViewScaleByPerc(perc, render) {
    SYOSSeatView$$1.SCALE_PERC *= perc;

    if (SYOSSeatView$$1.SCALE_PERC < SYOSSeatView$$1.MIN_SCALE) {
      SYOSSeatView$$1.SCALE_PERC = SYOSSeatView$$1.MIN_SCALE;
    } else if (SYOSSeatView$$1.SCALE_PERC > SYOSSeatView$$1.MAX_SCALE) {
      SYOSSeatView$$1.SCALE_PERC = SYOSSeatView$$1.MAX_SCALE;
    }

    SYOSSeat$$1.WIDTH = this.bounds.width * SYOSSeatView$$1.SCALE_PERC * SYOSSeat$$1.WIDTH_RATIO;
    SYOSSeat$$1.HALF_WIDTH = SYOSSeat$$1.WIDTH * 0.5;

    if (render !== false) {
      this.renderAll();
    }

    this.updateZoomControl();

    SYOSSeatView$$1.PREV_SCALE_PERC = SYOSSeatView$$1.SCALE_PERC;
  },

  cancelSeatViewAppearDelay: function cancelSeatViewAppearDelay() {
    if (this.seatViewAppearDelay) {
      this.seatViewAppearDelay.stop();
      this.seatViewAppearDelay = null;
    }
  },

  updateLegendSeatTypeIcons: function updateLegendSeatTypeIcons() {
    var iconsByLabel = {};
    var seatsWithIcons = this.seats.findAll(function (seat) {
      return seat.iconStateImages;
    });

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = seatsWithIcons[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var seat = _step3.value;

        if (!iconsByLabel[seat.displayMessage]) {
          // IE10 bug - can't use the same image (possibly just an svg image? or a url blob image? dunno!)
          // to draw onto the canvas and as a standard image element.
          // Work around by creating a new image element here.
          var img = new Image();
          img.src = seat.iconStateImages[SYOSSeatRenderingState.AVAILABLE].src;
          iconsByLabel[seat.displayMessage] = img;
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    this.legend.setSeatTypeIcons(iconsByLabel);
  },

  buildOutSeatsForFloor: function buildOutSeatsForFloor(seatData, floor) {

    // Reset a bunch of stuff while I have a reference to 'floor'
    this.seatViewMainContainer.setOpacity(0);

    this.removeAllSeats();
    this.seatViewInitialized = false;
    this.readyToRender = false;

    SYOSSeatView$$1.MIN_SCALE = floor.data.minScale || 0.25;
    SYOSSeatView$$1.MAX_SCALE = floor.data.maxScale || 3;

    SYOSSeatView$$1.SCALE_PERC = SYOSSeatView$$1.PREV_SCALE_PERC = floor.data.seatViewScalePerc || 1;
    SYOSSeat$$1.SCALE_PERC = floor.data.individualSeatScalePerc || 1;

    SYOSSeat$$1.WIDTH = SYOSSeat$$1.BASE_WIDTH * SYOSSeat$$1.SCALE_PERC;
    SYOSSeat$$1.HALF_WIDTH = SYOSSeat$$1.WIDTH * 0.5;

    SYOSSeatView$$1.Padding = {
      top: 50,
      bottom: 50,
      left: 50,
      right: 50
    };

    this.dragModifier = { x: 0, y: 0 };
    this.currDraggingModifier = { x: 0, y: 0 };
    this.transformCenterPoint = { x: 0, y: 0 };
    this.transformStartCenterPoint = { x: 0, y: 0 };
    this.transformStartScale = SYOSSeatView$$1.SCALE_PERC;
    this.photoPreviewData = floor.getPhotoPreviewData();

    var preppedSeatData = [];
    var syosHouse = this.syos.getHouseInstance();

    seatData.each(function (data) {

      var thisSeat = {};

      if (typeof data === 'string') {

        var dataArr = data.split(",");

        thisSeat.x = Number(dataArr[9]);
        thisSeat.y = Number(dataArr[10]);

        if (thisSeat.x === 0 && thisSeat.y === 0) return;

        thisSeat.secNum = dataArr[0];
        thisSeat.row = dataArr[1];
        thisSeat.seatNum = dataArr[2];
        thisSeat.seatId = parseInt(dataArr[4], 10);
        thisSeat.zoneNum = dataArr[5];
        thisSeat.holdCode = 0;
        thisSeat.seatType = parseInt(dataArr[7], 10);
        thisSeat.isAvailable = dataArr[8] === "Y";
      } else {

        thisSeat.secNum = data.sec;
        thisSeat.row = data.row;
        thisSeat.seatNum = data.num;
        thisSeat.seatId = data.id;
        thisSeat.zoneNum = data.zone;
        thisSeat.seatType = typeof data.type === 'undefined' ? 1 : data.type;
        thisSeat.holdCode = typeof data.hold === 'undefined' ? 0 : data.hold;
        thisSeat.isAvailable = !!data.avail;
        thisSeat.x = data.x;
        thisSeat.y = data.y;
      }

      if (floor.data.flipVertical) {
        thisSeat.x *= -1;
        thisSeat.y *= -1;
      }

      preppedSeatData.push(thisSeat);
    });

    var currentSeatIds = this.cart.getCurrentSeatIds();
    var frontLoadedSeatIds = this.syos.getFrontLoadedSeatIds();
    var currentSeatIdIndex = void 0;
    var newSeat = void 0;

    this.seats = [];
    preppedSeatData.each(function (seatData) {

      newSeat = null;

      if (currentSeatIds) {
        currentSeatIdIndex = currentSeatIds.indexOf(seatData.seatId);
        if (currentSeatIdIndex !== -1) {
          newSeat = this.cart.getSeatForSeatId(seatData.seatId);
          currentSeatIds.splice(currentSeatIdIndex, 1);
          if (!currentSeatIds.length) {
            currentSeatIds = null;
          }
        }
      }

      if (newSeat === null) {

        // check to see if this seat is frontloaded, meaning it should show up as available,
        // even if it has since been removed from the cart.

        if (frontLoadedSeatIds.indexOf(seatData.seatId) !== -1) {
          seatData.isAvailable = true;
        }

        newSeat = new SYOSSeat$$1(this.syos, this, syosHouse, seatData, this.allSeatsMode);
      } else {
        newSeat.x = seatData.x;
        newSeat.y = seatData.y;
      }

      if (newSeat.isFrontLoaded) {
        newSeat.data.secNum = seatData.secNum;
      }

      this.seats.push(newSeat);
    }, this);

    this.checkForHighlightSamePrice();
    this.updateLegendSeatTypeIcons();

    if (floor.data.backgroundImage) {
      this.updateBackgroundImage(floor.data.backgroundImage);
    } else {
      this.firstRender();
    }
  },

  firstRender: function firstRender() {

    document.fire(SYOSEvents.SEAT_DATA_LOADED);

    this.seatViewAppearDelay = new PeriodicalExecuter(function (pe) {
      this.cancelSeatViewAppearDelay();

      this.seatViewMainContainer.appear({
        duration: 0.45,
        afterFinish: function () {
          this.renderAll();
        }.bind(this)
      });
    }.bind(this), 0.25);

    this.finalizeSeatCoords();
    this.readyToRender = true;
    this.onResize();
    this.updateZoomControl();
  },

  finalizeSeatCoords: function finalizeSeatCoords() {

    var bounds = {};

    this.bounds = bounds;

    this.seats.each(function (seat) {

      var seatX = seat.x;
      var seatY = seat.y;

      if (!bounds.x || seatX < bounds.x) bounds.x = seatX;
      if (!bounds.y || seatY < bounds.y) bounds.y = seatY;
      if (!bounds.width || seatX > bounds.width) bounds.width = seatX;
      if (!bounds.height || seatY > bounds.height) bounds.height = seatY;
    });

    this.seats.each(function (seat) {
      seat.x -= bounds.x;
      seat.y -= bounds.y;
    });

    bounds.width = bounds.width - bounds.x;
    bounds.height = bounds.height - bounds.y;
    bounds.x = bounds.y = 0;

    var seatBackgroundShiftX = 0;
    var seatBackgroundShiftY = 0;
    var backgroundData = this.backgroundData;

    if (this.backgroundImage) {

      // TODO: Factor in backgroundData.scaleMod for all cases

      if (backgroundData.x < 0) {
        if (backgroundData.naturalWidth > bounds.width - backgroundData.x) {
          bounds.width = backgroundData.naturalWidth;
        } else {
          bounds.width -= backgroundData.x - SYOSSeat$$1.WIDTH;
        }
      } else {
        if (backgroundData.naturalWidth + backgroundData.x > bounds.width) {
          bounds.width = backgroundData.naturalWidth + backgroundData.x;
        } else {
          bounds.width += SYOSSeat$$1.WIDTH;
        }
      }

      if (backgroundData.y < 0) {
        if (backgroundData.naturalHeight > bounds.height - backgroundData.y) {
          bounds.height = backgroundData.naturalHeight;
        } else {
          bounds.height -= backgroundData.y - SYOSSeat$$1.WIDTH;
        }
      } else {
        if ((backgroundData.naturalHeight + backgroundData.y) * backgroundData.scaleMod > bounds.height) {
          bounds.height = (backgroundData.naturalHeight + backgroundData.y) * backgroundData.scaleMod;
        } else {
          //noinspection JSSuspiciousNameCombination
          bounds.height += SYOSSeat$$1.WIDTH;
        }
      }

      if (backgroundData.x < 0) {
        seatBackgroundShiftX = -Math.ceil(backgroundData.x);
        backgroundData.x = 0;
      }
      if (backgroundData.y < 0) {
        seatBackgroundShiftY = Math.ceil(backgroundData.y);
        backgroundData.y = 0;
      }
    }

    SYOSSeat$$1.WIDTH_RATIO = SYOSSeat$$1.WIDTH / (this.getScaledBounds().width - SYOSSeat$$1.WIDTH);

    this.seats.each(function (seat) {
      seat.x += seatBackgroundShiftX;
      seat.y -= seatBackgroundShiftY;
    }, this);
  },

  checkForHighlightSamePrice: function checkForHighlightSamePrice() {

    this.highlightSamePrice = this.highlightSamePriceConfig;

    if (this.alwaysHighlightSamePrice === false) {
      // Turn off 'highlightSamePrice' if there is only one price
      if (this.highlightSamePrice) {
        var numSeatPrices = this.seats.pluck('comparePrice').uniq().without(0).length;
        if (numSeatPrices === 1) {
          this.highlightSamePrice = false;
        }
      }
    }
  },

  updateZoomControl: function updateZoomControl() {
    this.zoomControl.setToPerc((SYOSSeatView$$1.SCALE_PERC - SYOSSeatView$$1.MIN_SCALE) / (SYOSSeatView$$1.MAX_SCALE - SYOSSeatView$$1.MIN_SCALE));
  },

  getScaledBounds: function getScaledBounds(perc) {
    perc = perc || SYOSSeatView$$1.SCALE_PERC;
    return {
      x: this.bounds.x,
      y: this.bounds.y,
      width: this.bounds.width * perc /*+ SYOSSeat.WIDTH*/
      , height: this.bounds.height * perc /*+ SYOSSeat.WIDTH*/
    };
  },

  removeAllSeats: function removeAllSeats() {
    this.readyToRender = false;
    this.bounds = null;
    if (this.seats) {
      this.seats.each(function (seat) {
        seat.destroy();
      });
      this.seats = null;
    }
  },

  doCurrFloor: function doCurrFloor(event) {
    if (SYOSFloor.currFloor) {
      this.seatViewMainContainer.setOpacity(0);
      this.seatViewMainContainer.show();
    } else {
      this.cancelSeatViewAppearDelay();
      this.seatViewMainContainer.hide();
      this.removeAllSeats();
      this.updateBackgroundImage(null);
      // this.renderAll();
    }
  },

  updateBackgroundImage: function updateBackgroundImage(backgroundData) {

    this.backgroundImage = null;
    this.backgroundData = null;

    if (backgroundData) {
      this.backgroundData = Object.clone(backgroundData);
      this.backgroundImage = new Element('img');
      this.backgroundImage.on('load', this.onBackgroundImageLoad.bind(this));

      var backgroundImageSrc = window.pRube ? this.syos.modulePath + 'syos_local/' + this.backgroundData.src : this.backgroundData.src;

      this.backgroundImage.writeAttribute('src', backgroundImageSrc);
    }
  },

  onBackgroundImageLoad: function onBackgroundImageLoad(event) {

    var allDoneHere = function () {
      this.backgroundImage.purge();
      this.firstRender();
    }.bind(this);

    if (this.backgroundData.naturalWidth && this.backgroundData.naturalHeight) {
      // Still having issues with IE11 finding out the dimensions,
      // so pre-populate these values in the house config.
      // This is the preferred way of handling this moving forward.
      allDoneHere();
      return;
    }

    var naturalWidth = this.backgroundImage.naturalWidth || 0;
    var naturalHeight = this.backgroundImage.naturalHeight || 0;

    // See IE11 below
    var done = function () {
      if (naturalWidth && naturalHeight) {
        this.backgroundData.naturalWidth = naturalWidth;
        this.backgroundData.naturalHeight = naturalHeight;
      }
      allDoneHere();
    }.bind(this);

    if (naturalWidth === 0 && naturalHeight === 0) {
      // IE doesn't support naturalWidth/naturalHeight. Try the width & height attrs with IE <= 10
      var widthAttr = this.backgroundImage.readAttribute('width');
      var heightAttr = this.backgroundImage.readAttribute('height');
      if (widthAttr && heightAttr) {
        naturalWidth = parseInt(widthAttr, 10);
        naturalHeight = parseInt(heightAttr, 10);
      } else {
        // With IE 11, the image has to be in the DOM and we have to wait a bit, then we can get it's dimensions
        this.syos.syosMainContainer.insert(this.backgroundImage);
        setTimeout(function () {
          var dimensions = this.backgroundImage.getDimensions();
          naturalWidth = parseInt(dimensions.width, 10);
          naturalHeight = parseInt(dimensions.height, 10);
          this.backgroundImage.remove();
          done();
        }.bind(this), 1);
        return;
      }
    }

    done();
  },

  cancelZoomAnimation: function cancelZoomAnimation() {
    if (this.zoomAnimation) {
      this.zoomAnimation.cancel();
      this.zoomAnimation = null;
    }
  },

  destroy: function destroy() {

    this.syos = null;
    this.cart = null;

    this.zoomControl.destroy();
    this.zoomControl = null;

    this.docHandlers.invoke("stop");
    this.docHandlers = null;

    this.hammer.off('touch release dragstart drag dragend tap doubletap transformstart transformend pinch');
    this.hammer = null;

    this.cancelSeatViewAppearDelay();
    this.cancelZoomAnimation();

    SYOSSeatView$$1.instance = null;

    this.removeAllSeats();
  }
});

SYOSSeatView$$1.WHITE = '#FFF';
SYOSSeatView$$1.BLACK = '#000';
SYOSSeatView$$1.CANVAS_FONT = '11pt Helvetica';
SYOSSeatView$$1.MARGIN = 50;
SYOSSeatView$$1.MARGIN_FILL = 'rgba(255,255,0,1)';
SYOSSeatView$$1.BOUNDS_FILL = 'rgba(0,0,0,.25)';
SYOSSeatView$$1.CURSOR_DEFAULT = 'default';
SYOSSeatView$$1.CURSOR_POINTER = 'pointer';
SYOSSeatView$$1.CURSOR_MOVE = 'move';
SYOSSeatView$$1.PHOTO_PLOT_SRC = 'data:image/png;base64,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';
SYOSSeatView$$1.PHOTO_PLOT_WIDTH = 40;
SYOSSeatView$$1.PHOTO_PLOT_HALF_WIDTH = SYOSSeatView$$1.PHOTO_PLOT_WIDTH * 0.5;
SYOSSeatView$$1.HOVER_TYPE_SEAT = 'seat';
SYOSSeatView$$1.HOVER_TYPE_PHOTO_PLOT = 'photoPlot';

SYOSSeatView$$1.SHOW_LOCAL_COORDS = false;
SYOSSeatView$$1.DRAW_SCALE_PERC = false;
SYOSSeatView$$1.DRAW_MARGIN = false;
SYOSSeatView$$1.DRAW_BOUNDS = false;

SYOSSeatView$$1.resetScale = function () {
  if (SYOSSeatView$$1.instance) {
    SYOSSeatView$$1.SCALE_PERC = 1;
    SYOSSeatView$$1.instance.updateSeatViewScaleByPerc(1);
  }
};

var SYOSSeat$$1 = Class.create({

  /**
   *  Having a 'selectedPricetype' is the main flag for a seat having been selected and 'being in the cart'.
   *  SYOSCart retains SYOSSeat instances (though SYOSCartSeat), which get re-used if the SYOSSeatView rebuilds its section
   *  Note that SYOSSeat.destroy() does not always destroy' the instance - just check it out!
   */

  // data               :: Object
  // selectedPricetype  :: { id: "444", price: 234 }

  initialize: function initialize(syos, seatView, syosHouse, seatData, allSeatsMode) {

    this.syos = syos;
    this.seatView = seatView;

    this.x = seatData.x;
    this.y = seatData.y;

    var displayType = DisplayTypes.STANDARD;
    var isAccessible = false;
    var displayMessage = null;

    if (seatData.seatType !== 1) {
      var data = SYOSMain.seatTypes[seatData.seatType];
      if (data) {
        displayMessage = data.label || 'Seat Type: ' + seatData.seatType;
        displayType = data.displayType;
        isAccessible = data.isAccessible;
      }
    }
    if (seatData.holdCode !== 0) {
      var _data = SYOSMain.holdCodes[seatData.holdCode];
      if (_data) {
        displayMessage = _data.label || 'Hold Code: ' + seatData.holdCode;
        displayType = _data.displayType;
        isAccessible = _data.isAccessible;
      }
    }

    this.isAccessible = isAccessible;
    this.displayType = displayType;
    this.iconStateImages = SYOSSeatIcons.getIconStateImagesForSeatDisplayType(this.displayType);

    if (this.displayType === DisplayTypes.STANDARD) {
      displayMessage = null;
    }

    this.displayMessage = displayMessage;

    this.isAvailable = seatData.isAvailable || allSeatsMode;

    this.hex = syosHouse.hexCodeForZoneId(seatData.zoneNum, this.isAvailable) || (seatData.isAvailable ? SYOSSeat$$1.COLOR_AVAIL : SYOSSeat$$1.COLOR_UNAVAIL);

    if (allSeatsMode && syos.mode === SYOSMode.SEAT_PREVIEW) {
      this.hex = SYOSSeat$$1.COLOR_UNAVAIL;
    }

    this.data = seatData;

    // this could be optimized but i don't think it's bottlenecking anything
    var availPricetypes = this.getAvailPricetypes();
    this.comparePrice = availPricetypes.length ? availPricetypes[0].price : 0;
  },

  getSeatId: function getSeatId() {
    return this.data.seatId;
  },

  getCartDisplayString: function getCartDisplayString() {
    return this.data.row + "-" + this.data.seatNum;
  },

  getSelectedPricetypeDescription: function getSelectedPricetypeDescription() {
    // ie "Adult"
    return this.syos.summaryDataForPricetypeId(this.selectedPricetype.id).desc;
  },

  getSelectedPricetypePrice: function getSelectedPricetypePrice() {
    return this.selectedPricetype.price;
  },

  getSelectedPricetypeId: function getSelectedPricetypeId() {
    return this.selectedPricetype ? this.selectedPricetype.id : null;
  },

  getAvailPricetypes: function getAvailPricetypes() {
    return this.syos.summaryDataForZoneId(this.data.zoneNum).pricetypes;
  },

  getSectionData: function getSectionData() {
    return this.syos.summaryDataForSectionNum(this.data.secNum);
  },
  getZoneData: function getZoneData() {
    return this.syos.summaryDataForZoneId(this.data.zoneNum);
  },

  doClick: function doClick(event) {

    document.fire(SYOSEvents.SEAT_CLICK, this);

    if (this.selectedPricetype) {
      // seat is in cart
      this.setSelectedPricetype(null);
    }
  },

  getSelectedPrice: function getSelectedPrice() {
    return this.selectedPricetype.price;
  },

  setSelectedPricetype: function setSelectedPricetype(pricetype) {
    this.selectedPricetype = pricetype;
    if (this.selectedPricetype) {
      document.fire(SYOSEvents.ADD_SEAT_TO_CART, this);
    } else {
      document.fire(SYOSEvents.REMOVE_SEAT_FROM_CART, this);
    }
  },

  render: function render(ctx, x, y, state, color) {

    switch (this.displayType) {
      case DisplayTypes.STANDARD:
      case DisplayTypes.DONUT:

        ctx.beginPath();
        ctx.fillStyle = color;
        ctx.arc(x, y, SYOSSeat$$1.HALF_WIDTH, 0, Math.PI * 2, true);
        ctx.fill();
        ctx.closePath();

        if (this.displayType === DisplayTypes.DONUT) {
          ctx.beginPath();
          ctx.fillStyle = SYOSSeatView$$1.WHITE;
          ctx.arc(x, y, SYOSSeat$$1.HALF_WIDTH * 0.4, 0, Math.PI * 2, true);
          ctx.fill();
          ctx.closePath();
        }
        break;

      case DisplayTypes.WHEELCHAIR:
      case DisplayTypes.COMPANION:

        if (state === null) {
          if (this.isAvailable) {
            state = SYOSSeatRenderingState.AVAILABLE;
          } else {
            state = SYOSSeatRenderingState.DISABLED;
          }
        }

        //ctx.beginPath();
        //ctx.fillStyle = '#333';
        //ctx.arc(x, y, SYOSSeat.HALF_WIDTH, 0, Math.PI * 2, true);
        //ctx.fill();
        //ctx.closePath();
        ctx.drawImage(this.iconStateImages[state], x - SYOSSeat$$1.HALF_WIDTH, y - SYOSSeat$$1.HALF_WIDTH, SYOSSeat$$1.WIDTH, SYOSSeat$$1.WIDTH);

    }

    // var seatDetails = seat.data.secNum + '-' + seat.data.row + '-' + seat.data.seatNum;
    // ctx.font = "9px Monaco";
    // ctx.fillStyle = syosImageSrc(seat.data.secNum, seat.data.row, seat.data.seatNum) ? 'green' : 'white';
    // var seatDetailsWidth = ctx.measureText(seatDetails).width;
    // ctx.fillText(seatDetails, x - seatDetailsWidth * 0.5, y + 4);
  },


  getReserveSeatsData: function getReserveSeatsData() {
    return {
      id: this.data.seatId,
      hold: this.data.holdCode,
      pricetype: this.selectedPricetype.id
    };
  },

  destroy: function destroy() {

    if (this.selectedPricetype) {} else {

      this.syos = null;
      this.seatView = null;
    }
  }

});

SYOSSeat$$1.BASE_WIDTH = 20; // Don't change this

var SYOSHouse = Class.create({

  // syosLegend      :: SYOSLegend

  // floors                    :: Array
  // data                      :: Object
  // docHandlers               :: Array
  // numFloors                 :: int

  // resetHTML                 :: String

  // mainContainer             :: Div Element

  // houseSVGRequest           :: Ajax.Request

  initialize: function initialize(houseData, syos) {

    this.syos = syos;

    this.floors = [];
    this.data = houseData;
    this.numFloors = houseData.floors.length;

    this.docHandlers = [document.on(SYOSEvents.CURR_FLOOR, this.doCurrFloor.bind(this)), document.on(SYOSEvents.SYOS_READY, this.doCurrFloor.bind(this)), document.on(SYOSEvents.RESIZE, this.onResize.bind(this))];

    this.mainContainer = syos.getDisplayElement().down('#syos-house');
    this.desktopDisplayContainer = syos.getDisplayElement().down('#syos-overview-desktop');
    this.mobileButtonsContainer = syos.getDisplayElement().down('#mobile-floor-buttons');
    this.resetHTML = this.mainContainer.innerHTML;

    // this.photoPreviewPlotContainer = this.mainContainer.down('#photo-plot-container');

    // this.mainContainer             = new Element("div", {id: "syosHouseContainer"});
    // this.photoPreviewPlotContainer = new Element("div", {"class": "syosPhotoPlotContainer"});
    // this.mainContainer.insert(this.overviewDisplay.getDisplayElement());

    // this.mainContainer.insert({top: this.photoPreviewPlotContainer});


    SYOSSeat$$1.COLOR_AVAIL = this.data.seatHexCodes.available || "#333";
    SYOSSeat$$1.COLOR_UNAVAIL = this.data.seatHexCodes.disabled || "#DDD";
    SYOSSeat$$1.COLOR_SELECTED = this.data.seatHexCodes.selected || "#009900";
    SYOSSeat$$1.COLOR_HOVER = this.data.seatHexCodes.hover || "#1e73e0";

    SYOSSeat$$1.COLOR_SAME_ZONE = this.data.seatHexCodes.sameZone || "#109ee0";
    SYOSSeat$$1.COLOR_SAME_ZONE_DISABLED = this.data.seatHexCodes.sameZoneDisabled || "#c4e7ff";

    if (this.numFloors === 1) {

      this.floors = [new SYOSFloor(this.syos, this, this.data.floors[0], null)];

      setTimeout(function () {
        document.fire(SYOSEvents.HOUSE_DATA_LOADED);
      }, 0);
    } else {

      this.houseSVGRequest = new Ajax.Request(this.syos.houseDataBaseURL + this.syos.getHouseId() + '.svg?cache=' + this.syos.cacheId, {
        method: "get",
        onException: this.syos.onAjaxError.bind(this.syos, SYOSEvents.SYOSHOUSE_SVG_EXCEPTION),
        onFailure: this.syos.onAjaxError.bind(this.syos, SYOSEvents.SYOSHOUSE_SVG_EXCEPTION),
        onSuccess: function (response) {
          if (this.syos.summaryDataLoaded) {
            this.onHouseSVGLoaded(response);
          } else {
            this.houseSVGRequestResponse = response;
            this.summaryDataLoadedHandler = document.on(SYOSEvents.SUMMARY_DATA_LOADED, this.onHouseSVGLoaded.bind(this));
          }
        }.bind(this)
      });
    }
  },

  onHouseSVGLoaded: function onHouseSVGLoaded(response) {

    if (!response.responseText) {
      response = this.houseSVGRequestResponse;
      this.houseSVGRequestResponse = null;
    }

    if (this.summaryDataLoadedHandler) {
      this.summaryDataLoadedHandler.stop();
      this.summaryDataLoadedHandler = null;
    }

    this.svgXMLString = response.responseText;

    var mainSVGElement = svgElFromString(this.svgXMLString);

    var houseSVGContainer = this.desktopDisplayContainer.down('#house-svg-container');

    mainSVGElement.setAttribute("id", "svg-container-" + this.syos.getHouseId());
    mainSVGElement.setAttribute("class", "svg-house");

    mainSVGElement = document.importNode(mainSVGElement, true);

    houseSVGContainer.appendChild(mainSVGElement);

    for (var i = 0; i < this.numFloors; i++) {
      var floorData = this.data.floors[i];
      var floorSVGGroupElement = this.desktopDisplayContainer.down('#syos-floor-' + (i + 1));

      var floor = new SYOSFloor(this.syos, this, floorData, floorSVGGroupElement);
      this.floors.push(floor);
    }

    document.fire(SYOSEvents.HOUSE_DATA_LOADED);
  },

  onResize: function onResize() {
    var mobileButtonContents = this.syos.getDisplayElement().select('.mobile-floor-button .contents');

    // reset
    mobileButtonContents.each(function (el) {
      el.setStyle({ height: '' });
    });

    // measure
    var maxContentHeight = mobileButtonContents.collect(function (el) {
      return el.getHeight();
    }).max();

    // set
    mobileButtonContents.each(function (el) {
      var parent = el.up();
      el.remove();
      el.setStyle({ height: maxContentHeight + 'px' });
      parent.insert(el);
    });
  },

  updateSummaryData: function updateSummaryData(summaryData) {
    if (this.floors.length > 1) {

      var mobileFloorPricetypeTemplate = new Template(this.syos.getDisplayElement().down('#mobile-floor-button-pricetype').getValue());
      var mobileFloorButtonTemplate = new Template(this.syos.getDisplayElement().down('#mobile-floor-button').getValue());

      for (var i = 0; i < this.floors.length; i++) {

        var floor = this.floors[i];
        var floorSummaryData = floor.getSummaryData();
        var mobileButton = new Element('div').update(mobileFloorButtonTemplate.evaluate(floorSummaryData));

        mobileButton = mobileButton.firstDescendant();
        mobileButton.down('.unavail').update(SYOSMessage$$1.applyTemplate(SYOSMessageTemplates.labelFloorSoldOut));

        var pricetypesContainer = mobileButton.down('.pricetypes');
        var mobileSVG = svgElFromString(this.svgXMLString);
        var j = void 0;

        mobileButton.down('.svg-container').insert(mobileSVG);
        var mobileFloorGroupEl = mobileButton.down('#syos-floor-' + (i + 1));
        if (mobileFloorGroupEl.classList) {
          mobileFloorGroupEl.classList.add('highlight');
        } else {
          mobileFloorGroupEl.setAttribute('class', 'highlight');
        }

        for (j = 0; j < floorSummaryData.pricetypeSummaryLabels.regular.length; j++) {
          pricetypesContainer.insert(mobileFloorPricetypeTemplate.evaluate({
            name: floorSummaryData.pricetypeSummaryLabels.regular[j],
            price: floorSummaryData.pricetypeSummaryPrices.regular[j]
          }));
        }
        if (floorSummaryData.pricetypeSummaryLabels["nfs-add-on"].length) {
          pricetypesContainer.insert(new Element("div", { "class": "add-on-break" }).update("Extra Single Tickets"));
          for (j = 0; j < floorSummaryData.pricetypeSummaryLabels["nfs-add-on"].length; j++) {
            pricetypesContainer.insert(mobileFloorPricetypeTemplate.evaluate({
              name: floorSummaryData.pricetypeSummaryLabels["nfs-add-on"][j],
              price: floorSummaryData.pricetypeSummaryPrices["nfs-add-on"][j]
            }));
          }
        }

        this.mobileButtonsContainer.insert(mobileButton);
        floor.setMobileButton(mobileButton);
      }
    }
  },

  hexCodeForZoneId: function hexCodeForZoneId(zoneId, enabled) {
    var zoneName = this.syos.summaryDataForZoneId(zoneId).name;
    var hex = this.data.hexCodesByZoneLabel[zoneName] || null;

    if (hex && !enabled) {
      var disabledHex = this.data.hexCodesByZoneLabel[zoneName + "_disabled"] || null;
      if (!disabledHex) {
        disabledHex = 'rgba(' + SYOSMisc.hexToRgb(hex) + ', 0.2)';
        this.data.hexCodesByZoneLabel[zoneName + "_disabled"] = disabledHex;
      }
      return disabledHex;
    }
    return hex;
  },

  getName: function getName() {
    return SYOSHouse.displayNameForHouseId(this.data.houseId);
  },

  getPhotoPreviewData: function getPhotoPreviewData() {
    return this.data.photoPreviews || [];
  },

  doCurrFloor: function doCurrFloor(event) {

    if (SYOSFloor.currFloor) {

      this.fadeOutHouse();
    } else {

      this.fadeInHouse();
    }
  },

  fadeInHouse: function fadeInHouse() {
    this.cancelCurrHouseAni();
    this.mainContainer.show();
    this.onResize();
  },

  fadeOutHouse: function fadeOutHouse() {
    this.cancelCurrHouseAni();
    this.mainContainer.hide();
  },

  cancelCurrHouseAni: function cancelCurrHouseAni() {
    Effect.Queues.get('syosHouse').invoke('cancel');
  },

  destroy: function destroy() {

    this.syos = null;

    if (this.houseSVGRequest) this.houseSVGRequest.transport.abort();
    this.houseSVGRequest = null;

    this.cancelCurrHouseAni();

    this.desktopDisplayContainer = null;

    this.floors.invoke("destroy");
    this.floors = null;

    this.mainContainer.update(this.resetHTML);

    this.docHandlers.invoke("stop");
    this.docHandlers = null;

    if (this.summaryDataLoadedHandler) {
      this.summaryDataLoadedHandler.stop();
      this.summaryDataLoadedHandler = null;
    }
  }

});

SYOSHouse.displayNameForHouseId = function (houseId) {
  return SYOSHouse.houseDisplayNames[houseId] || "Venue";
};

var SYOSDateSwitch = Class.create({

  // syos                 :: SYOSMain

  // typeId               :: String
  // currPId              :: String
  // docHandlers          :: Array

  // mainContainer        :: Div Element
  // dropDown             :: Select Element

  initialize: function initialize(syos, pId, typeId, templateString) {

    // TODO: Always reference pId and typeId from syos reference?

    this.syos = syos;

    // this gets run through moment, then replaces Prototype Template-esque
    // symbol #{venueName} with the actual venue name
    this.templateString = templateString || 'ddd, MMMM D, YYYY, h:mm A, [#{venueName}]';

    this.typeId = typeId.toLowerCase();
    this.currPId = "" + pId;

    this.docHandlers = [document.on(SYOSEvents.SYOS_READY, this.doSYOSDataLoaded.bind(this))];

    /*
    this.testData = {
      alternates: [
        {date: "2011-11-10T11:00:00-06:00", name: "The Music of John Denver", id: "2696"},
        {date: "2011-11-11T20:00:00-06:00", name: "The Music of John Denver", id: "999"},
        {date: "2011-11-12T20:00:00-06:00", name: "The Music of John Denver", id: "2696"}
      ]
    };
    */

    this.mainContainer = syos.getDisplayElement().down('#syos-date-switch');
    this.perfName = syos.getDisplayElement().down('#perf-name');
    this.dropDown = this.mainContainer.down('select');

    if (this.syos.mode === SYOSMode.SEAT_PREVIEW) {
      this.mainContainer.hide();
    }
  },

  doSYOSDataLoaded: function doSYOSDataLoaded(event) {

    this.docHandlers.invoke('stop');

    this.docHandlers = [document.on(SYOSEvents.SUMMARY_DATA_LOAD_BEGIN, this.disableDropDown.bind(this)), document.on(SYOSEvents.SEAT_DATA_LOAD_BEGIN, this.disableDropDown.bind(this)), document.on(SYOSEvents.SUMMARY_DATA_LOADED, this.enableDropDown.bind(this)), document.on(SYOSEvents.SEAT_DATA_LOADED, this.enableDropDown.bind(this)), document.on(SYOSEvents.SEAT_AVAIL_CHECK_BEGIN, this.disableDropDown.bind(this)), document.on(SYOSEvents.SEAT_AVAIL_CHECK_FAIL, this.enableDropDown.bind(this))];

    this.enableDropDown();
  },

  disableDropDown: function disableDropDown(event) {
    // if (this.dropDown) {
    this.dropDown.disable();
    // }
  },
  enableDropDown: function enableDropDown(event) {
    // if (this.dropDown) {
    this.dropDown.enable();
    // }
  },

  setData: function setData(data) {
    this.data = data;
    this.populate();
  },

  populate: function populate() {

    var displayValue = void 0;
    var currData = void 0;

    // this.data.alternates = [this.data.alternates[0]]; // To test a single alternate...

    if (this.data.alternates.length > 1 && this.data.alternates.any(function (alt) {
      return alt.houseId && alt.id;
    })) {

      this.mainContainer.down('.alternates-available').show();

      this.dropDown.on("change", this.doDropDownChange.bind(this));

      this.data.alternates.each(function (data) {

        if (!data.houseId || !data.id) return;

        var displayValue,
            venueName = SYOSHouse.displayNameForHouseId(data.houseId);

        if (this.typeId == 'perf') {
          displayValue = this.formatDisplayString(data.date, venueName);
        } else {
          displayValue = data.name + ', ' + venueName;
        }

        data.displayValue = displayValue;

        var option = new Element("option", { value: data.id }).update(displayValue);

        if (data.id == this.currPId) {
          currData = data;
          option.setAttribute("selected", "selected");
        }

        this.dropDown.insert(option);
      }, this);
    } else {

      var o = this.data.alternates[0];
      var venueName = SYOSHouse.displayNameForHouseId(o.houseId);

      currData = o;

      if (this.typeId == 'perf') {
        displayValue = o.name + '<span class="date">' + this.formatDisplayString(o.date, venueName) + '</span>';
      } else {
        displayValue = o.name; // TODO: Polish this up
      }

      o.displayValue = displayValue;

      var noAlternatesEl = this.mainContainer.down('.no-alternates');
      noAlternatesEl.update(displayValue);
      noAlternatesEl.show();
    }

    if (currData) {
      this.perfName.update(currData.name);

      var seatPreviewModeDetailsLabel = this.syos.syosMainContainer.down("#syos-mode-seat-preview-details-label");
      if (seatPreviewModeDetailsLabel) {
        seatPreviewModeDetailsLabel.update(currData.displayValue);
      }
    }
  },

  formatDisplayString: function formatDisplayString(dateString, venueName) {
    return moment(dateString, 'YYYY-MM-DDTHH:mm:ss').format(this.templateString).replace('#{venueName}', venueName);
  },

  doDropDownChange: function doDropDownChange(event) {
    this.currPId = this.dropDown.getValue();

    var currData = this.data.alternates.detect(function (o) {
      return o.id == this.currPId;
    }, this);

    this.dropDown.disable();

    this.syos.setPIdForHouse(this.currPId, currData.houseId);
  },

  destroy: function destroy() {

    this.syos = null;

    this.docHandlers.invoke("stop");
    this.docHandlers = null;

    this.dropDown.purge();
    this.dropDown = null;

    this.mainContainer = null;
  }

});

var SYOSCartSeat = Class.create({

  // seat          :: SYOSSeat
  // floorLabel    :: String
  // mainContainer :: Div Element
  // buttonRemove  :: Div Element

  initialize: function initialize(seat, cart, floorLabel) {

    //this.cart = cart;
    this.seat = seat;
    this.floorLabel = floorLabel;
    this.mainContainer = new Element("div", { "class": "syos-cart-item" });

    var rowSeatElement = new Element("div", { "class": "row-seat" }).update(seat.getCartDisplayString() + ", " + seat.getSelectedPricetypeDescription());
    var priceElement = new Element("div", { "class": "price" }).update("$" + seat.getSelectedPricetypePrice().toMoney());
    this.buttonRemove = new Element("div", { "class": "btn-remove" }).update('Ã—');

    this.mainContainer.insert(rowSeatElement);
    this.mainContainer.insert(priceElement);
    this.mainContainer.insert(this.buttonRemove);

    this.buttonRemove.on("click", this.removeSeatFromCart.bind(this));
  },

  getFloorLabel: function getFloorLabel() {
    return this.floorLabel;
  },

  getDisplayElement: function getDisplayElement() {
    return this.mainContainer;
  },

  getSeatId: function getSeatId() {
    return this.seat.getSeatId();
  },

  removeSeatFromCart: function removeSeatFromCart(event) {
    this.seat.setSelectedPricetype(null);
  },

  destroy: function destroy() {
    this.buttonRemove.purge();
    this.seat = null;
  }

});

var SYOSCart$$1 = Class.create({

  // sectionedCartSeats      :: Prototype Hash : { 'Floor 1': { headerElement: [DIV Element], cartSeats: [SYOSCartSeat, SYOSCartSeat, ...] }, 'Floor 2': ... }
  // summaryIsOpen           :: Bool
  // isVisible               :: Bool
  // docHandlers             :: Array

  // mainContainer           :: Div Element
  // addToCartButton         :: Div Element
  // cartSeatsContainer      :: Div Element
  // summarySlideContainer   :: Div Element
  // summaryDisplay          :: Div Element

  // syos                    :: SYOSMain

  initialize: function initialize(syos, o) {

    this.syos = syos;

    this.cartSeatGrouping = o.cartSeatGrouping || 'floor';

    this.sectionedCartSeats = $H();
    // this.isVisible = false;

    this.isOpen = false;

    this.mainContainer = this.syos.getDisplayElement().down('#syos-cart');
    this.cartContents = this.mainContainer.down('#syos-cart-contents');
    this.cartHeader = this.mainContainer.down('.header');
    this.addToCartButton = this.mainContainer.down('#add-to-cart-button');
    this.cartSeatsContainer = this.mainContainer.down('#cart-seats');
    // this.summarySlideContainer   = this.mainContainer.down('#summary-slide-container');
    // this.summaryDisplayContainer = this.mainContainer.down('#summary-display-container');
    this.summaryDisplay = this.mainContainer.down('#cart-toggle');

    this.cartToggle = this.mainContainer.down('#cart-toggle');
    this.cartToggle.on('click', this.doCartToggleClick.bind(this));

    this.docHandlers = [document.on(SYOSEvents.RESIZE, this.onResize.bind(this)), document.on(SYOSEvents.ADD_SEAT_TO_CART, this.onAddSeatToCart.bind(this)), document.on(SYOSEvents.CURR_FLOOR, this.doCloseCart.bind(this)), document.on(SYOSEvents.REMOVE_SEAT_FROM_CART, this.onRemoveSeatFromCart.bind(this)), document.on(SYOSEvents.SUMMARY_DATA_LOAD_BEGIN, this.onSummaryDataLoadbegin.bind(this))];

    this.addToCartButton.on("click", this.doAddToCartClick.bind(this));

    if (this.syos.mode === SYOSMode.SEAT_PREVIEW) {
      this.mainContainer.hide();
    }
  },

  doCartToggleClick: function doCartToggleClick(event) {

    if (this.sectionedCartSeats.size()) {
      if (this.isOpen) {
        this.doCloseCart();
      } else {
        this.doOpenCart();
      }
    }
  },

  doCloseCart: function doCloseCart() {
    if (this.isOpen) {
      this.syos.closeCart();
      this.mainContainer.removeClassName('open').addClassName('closed').setStyle({ marginTop: '', height: '' });
      this.isOpen = false;
    }
  },
  doOpenCart: function doOpenCart() {
    if (!this.isOpen) {
      this.syos.openCart();
      this.positionForOpen();
      this.isOpen = true;

      if (!SYOSFloor.currFloor && SYOSMain.testIsMobileView()) {

        window.scrollTo(0, document.body.scrollHeight);

        var currScrollY = window.scrollY,
            targetHeight = this.cartContents.getHeight() + this.mainContainer.getHeight() + 20,
            maxHeight = SYOSMain.STAGE_HEIGHT + 45;

        targetHeight = targetHeight > maxHeight ? maxHeight : targetHeight;

        new Effect.Tween(null, 0, targetHeight, {
          duration: 0.25,
          fps: 60
        }, function (p) {
          window.scrollTo(0, currScrollY + Math.floor(p));
        });
      }
    }
  },

  onResize: function onResize(event) {
    if (this.isOpen) {
      this.positionForOpen();
    }
  },
  positionForOpen: function positionForOpen() {

    var height = this.cartContents.getHeight(),
        cappedHeight = height > SYOSMain.STAGE_HEIGHT ? SYOSMain.STAGE_HEIGHT : height;

    this.mainContainer.addClassName('open').removeClassName('closed').setStyle({
      height: height + 'px',
      marginTop: -cappedHeight + 'px'
    });
  },

  onSummaryDataLoadbegin: function onSummaryDataLoadbegin(event) {
    this.removeAllSeats();
  },

  removeAllSeats: function removeAllSeats() {
    var seatsToRemove = [];
    this.sectionedCartSeats.each(function (pair) {
      pair.value.cartSeats.each(function (cartSeat) {
        seatsToRemove.push(cartSeat.seat);
      });
    });
    seatsToRemove.each(function (seat) {
      seat.setSelectedPricetype(null);
    });

    // probably want to close cart here
  },

  createHeaderElement: function createHeaderElement(label) {
    return new Element("div", { "class": "cart-seat-header" }).update(label);
  },

  onAddSeatToCart: function onAddSeatToCart(event) {

    var seat = event.memo,
        frontLoadedSeats = this.syos.getFrontLoadedSeatIds(),
        groupingLabel,
        cartSeat,
        wasFrontLoaded = frontLoadedSeats.indexOf(seat.data.seatId) !== -1;

    if (this.cartSeatGrouping === 'nfscategories') {

      if (wasFrontLoaded) {
        if (seat.selectedPricetype.nfsAddOn) {
          groupingLabel = 'Previously Selected Extra Single Tickets';
        } else {
          groupingLabel = 'Previously Selected Season Ticket Seats';
        }
      } else if (seat.selectedPricetype.nfsAddOn) {
        groupingLabel = 'Extra Single Tickets';
      } else {
        groupingLabel = 'Season Ticket Seats';
      }
    } else if (wasFrontLoaded) {
      // Non-NFS front-loaded seat. We can't show the actual section label
      // becasue we don't have enough data at initial load, hence static label.
      groupingLabel = 'Previously Selected Seats';
    } else if (this.cartSeatGrouping === 'section') {
      groupingLabel = seat.getSectionData().name;
    } else if (this.cartSeatGrouping === 'zone') {
      groupingLabel = seat.getZoneData().name;
    } else {
      groupingLabel = SYOSFloor.currFloor.getFloorName();
    }

    cartSeat = new SYOSCartSeat(seat, this, groupingLabel);

    if (!this.sectionedCartSeats.get(groupingLabel)) {
      this.sectionedCartSeats.set(groupingLabel, { headerElement: this.createHeaderElement(groupingLabel), cartSeats: [] });
    }

    this.sectionedCartSeats.get(groupingLabel).cartSeats.push(cartSeat);

    this.updateDisplay();
  },
  onRemoveSeatFromCart: function onRemoveSeatFromCart(event) {

    var cartSeat = this.getCartSeatForSeat(event.memo);

    var cartSeatsSection = this.sectionedCartSeats.get(cartSeat.getFloorLabel());
    cartSeatsSection.cartSeats.splice(cartSeatsSection.cartSeats.indexOf(cartSeat), 1);

    if (cartSeatsSection.cartSeats.length === 0) {
      cartSeatsSection.headerElement.remove();
      this.sectionedCartSeats.unset(cartSeat.getFloorLabel());
    }

    cartSeat.getDisplayElement().remove();
    cartSeat.destroy();

    this.updateDisplay();
  },

  getCurrentSeatIds: function getCurrentSeatIds() {
    var seatIds = null;

    if (this.sectionedCartSeats.size()) {
      seatIds = [];
      this.sectionedCartSeats.each(function (pair) {
        pair.value.cartSeats.each(function (cartSeat) {
          seatIds.push(cartSeat.getSeatId());
        });
      });
    }

    return seatIds;
  },

  getSeatCount: function getSeatCount() {
    var ids = this.getCurrentSeatIds();
    if (ids) {
      return ids.length;
    } else {
      return 0;
    }
  },

  getCartSeatForSeat: function getCartSeatForSeat(seat) {
    var foundCartSeat = null;
    this.sectionedCartSeats.each(function (pair) {
      var section = pair.value;
      for (var i = 0, len = section.cartSeats.length; i < len; ++i) {
        var thisCartSeat = section.cartSeats[i];
        if (thisCartSeat.seat === seat) {
          foundCartSeat = thisCartSeat;
          throw $break;
        }
      }
    });
    return foundCartSeat;
  },

  getSeatForSeatId: function getSeatForSeatId(seatId) {
    var seat = null;
    this.sectionedCartSeats.each(function (pair) {
      if (seat) throw $break;
      var section = pair.value.cartSeats.each(function (cartSeat) {
        if (cartSeat.getSeatId() == seatId) {
          seat = cartSeat.seat;
          throw $break;
        }
      });
    });
    return seat;
  },

  getHeaderHeight: function getHeaderHeight() {
    return this.cartHeader.getHeight() - 2;
  },

  updateDisplay: function updateDisplay() {
    this.updateCartContents();
    this.showOrHideCart();

    if (this.sectionedCartSeats.size()) {
      if (this.isOpen) {
        this.positionForOpen();
      }
    } else {
      if (this.isOpen) {
        this.doCloseCart();
      }
    }
  },

  showOrHideCart: function showOrHideCart() {
    if (this.sectionedCartSeats.size()) {
      this.mainContainer.removeClassName('disabled');
      this.addToCartButton.removeClassName('disabled');
    } else {
      this.mainContainer.addClassName('disabled');
      this.addToCartButton.addClassName('disabled');
    }
  },

  /*
  doSummaryClick: function(event) {
    
    var targetHeight;
    var summaryButtonHeight = this.summaryDisplay.getHeight();
    
    if (this.summaryIsOpen) {
      
      targetHeight = summaryButtonHeight;
      
    } else {
      
      targetHeight = summaryButtonHeight + this.cartSeatsContainer.getHeight();
      
    }
    
    this.summarySlideContainer.morph(
      {height: targetHeight + "px"},
      {duration: 0.5}
    );
    
    this.summaryIsOpen = !this.summaryIsOpen;
    this.summaryDisplayContainer.toggleClassName("open");
    
  },
  */

  doAddToCartClick: function doAddToCartClick(event) {
    this.syos.reserveSeatsInCart();
  },

  updateCartContents: function updateCartContents() {

    var totalPrice = 0;
    var numSeats = 0;

    this.sectionedCartSeats.each(function (pair) {
      this.cartSeatsContainer.insert(pair.value.headerElement);

      pair.value.cartSeats.each(function (cartSeat) {
        numSeats++;
        totalPrice += cartSeat.seat.getSelectedPrice();
        this.cartSeatsContainer.insert(cartSeat.getDisplayElement());
      }, this);
    }, this);

    var itemOrItems = numSeats == 1 ? "item" : "items";
    this.summaryDisplay.update("$" + totalPrice.toMoney() + " for " + numSeats + " " + itemOrItems);

    this.summaryDisplay.setStyle({ color: '#FFFFFF' }).morph({ color: '#333333' }, { duration: 0.25 });
  },

  // updateCartSize: function() {

  //   if (this.summaryIsOpen) {
  //     var cartSeatsHeight = this.cartSeatsContainer.getHeight();
  //     var summaryButtonHeight = this.summaryDisplay.getHeight();
  //     // this.summarySlideContainer.setStyle({height: cartSeatsHeight + summaryButtonHeight + "px"});
  //   }

  // },

  getCartSeatsByPricetypeId: function getCartSeatsByPricetypeId() {

    var returnObj = {};

    this.sectionedCartSeats.each(function (section) {

      section.value.cartSeats.each(function (cartSeat) {
        var seat = cartSeat.seat,
            seatPricetypeId = seat.getSelectedPricetypeId();

        if (!returnObj[seatPricetypeId]) {
          returnObj[seatPricetypeId] = [];
        }

        returnObj[seatPricetypeId].push(seat);
      }, this);
    }, this);

    return returnObj;
  },

  destroy: function destroy() {

    this.syos = null;

    this.removeAllSeats();

    this.docHandlers.invoke("stop");
    this.docHandlers = null;

    // this.summaryDisplayContainer.purge();
    this.addToCartButton.purge();
  }

});

var SYOSInterstitialOverlay = Class.create(SYOSOverlay, {

  // message        :: Div Element
  // loadingSpinner :: Div Element

  initialize: function initialize($super, syos) {

    $super(syos, '#syos-interstitial-overlay');

    this.docHandlers.push(document.on(SYOSEvents.SYOS_READY, this.onSYOSDataLoaded.bind(this)));

    this.displayMessage("Loading...");
  },

  onSYOSDataLoaded: function onSYOSDataLoaded(event) {

    this.docHandlers = [document.on(SYOSEvents.CURR_FLOOR, this.doCurrFloor.bind(this)), document.on(SYOSEvents.SEAT_DATA_LOADED, this.hide.bind(this)), document.on(SYOSEvents.HOUSE_DATA_LOADED, this.hide.bind(this)), document.on(SYOSEvents.SUMMARY_DATA_LOADED, this.doSummaryDataLoaded.bind(this)), document.on(SYOSEvents.SUMMARY_DATA_LOAD_BEGIN, this.displayMessage.bind(this).curry("Refreshing Availability...")), document.on(SYOSEvents.VENUE_CHANGE, this.displayMessage.bind(this).curry("Changing Venue...")), document.on(SYOSEvents.SEAT_AVAIL_CHECK_BEGIN, this.displayMessage.bind(this).curry("Checking Seat Availability...")), document.on(SYOSEvents.SEAT_AVAIL_CHECK_SUCCESS, this.doSeatAvailCheckSuccess.bind(this))];

    this.hide();
  },

  doSummaryDataLoaded: function doSummaryDataLoaded(event) {
    if (SYOSFloor.currFloor) {
      this.displayMessage("Loading Seats...");
    } else {
      this.hide();
    }
  },

  doCurrFloor: function doCurrFloor(event) {
    if (SYOSFloor.currFloor) {
      this.displayMessage("Loading Seats...");
    }
  },

  doSeatAvailCheckSuccess: function doSeatAvailCheckSuccess(event) {
    if (event.memo.retainState === true) {
      this.hide();
    } else {
      this.displayMessage(event.memo.viewCartMessage || "Taking you to your cart.");
    }
  },
  displayMessage: function displayMessage(messageString) {
    // this.loadingSpinner.show();
    this.message.update(messageString);
    this.show();
  },

  destroy: function destroy($super) {
    $super();
  }

});

var SYOSAlert = Class.create(SYOSOverlay, {

  // message     :: Div Element
  // alertButton :: Div Element

  initialize: function initialize($super, syos) {

    $super(syos, '#syos-alert');

    this.initDocHandlers();

    this.alertButton = this.mainContainer.down('.alert-button');
    this.alertButton.on("click", this.hide.bind(this));

    this.hideQuickly();
  },

  alert: function alert(message) {
    this.message.update(message);
    this.show();
  },

  destroy: function destroy($super) {
    $super();
    this.alertButton.purge();
  },

  initDocHandlers: function initDocHandlers() {
    var eventTemplates = {};

    eventTemplates[SYOSEvents.SEAT_AVAIL_CHECK_FAIL] = SYOSMessageTemplates.seatsNoLongerAvailable;
    eventTemplates[SYOSEvents.EXACT_TICKET_COUNT_MISMATCH] = SYOSMessageTemplates.incorrectExactTicketCount;
    eventTemplates[SYOSEvents.MINIMUM_SEATS_FOR_PRICETYPES_NOT_ACQUIRED] = SYOSMessageTemplates.incorrectTicketCountForPricetype;
    eventTemplates[SYOSEvents.RESERVE_INVALID_GROUPED_TICKETS] = SYOSMessageTemplates.reserveInvalidGroupedTickets;
    eventTemplates[SYOSEvents.MAXIMUM_TICKET_COUNT_EXCEEDED] = SYOSMessageTemplates.maximumTicketCountExceeded;

    $H(eventTemplates).each(function (pair) {

      var handler = document.on(pair.key, function (event) {
        this.alert(SYOSMessage$$1.applyTemplate(pair.value, event.memo));
      }.bind(this));

      this.docHandlers.push(handler);
    }, this);
  }

});

var SYOSCloseDialogWithUnreservedSeatsMode = {
  CONFIRM_CLOSE: 1,
  RESERVE_SEATS: 2
};

var SYOSConfirmOverlay = Class.create(SYOSOverlay, {

  // message     :: Div Element
  // alertButton :: Div Element

  initialize: function initialize($super, syos, mode) {

    this.mode = mode || SYOSCloseDialogWithUnreservedSeatsMode.CONFIRM_CLOSE;

    $super(syos, $('syos-confirm-overlay'));

    this.yesButton = this.mainContainer.down('.yes-button');
    this.yesButton.on("click", this.onYesButton.bind(this));

    this.noButton = this.mainContainer.down('.no-button');
    this.noButton.on("click", this.onNoButton.bind(this));

    this.cancelButton = this.mainContainer.down('.cancel-button') || new Element('div');
    this.cancelButton.on("click", this.onCancelButton.bind(this));

    var confirmMessage;

    if (mode === SYOSCloseDialogWithUnreservedSeatsMode.RESERVE_SEATS) {
      confirmMessage = SYOSMessageTemplates.closeDialogWithUnreservedSeats_reserveSeats;
    } else {
      confirmMessage = SYOSMessageTemplates.closeDialogWithUnreservedSeats_confirmClose;
      this.cancelButton.hide();
    }

    this.docHandlers.push(document.on(SYOSEvents.CONFIRM_DIALOG_CLOSE, this.confirm.bind(this).curry(confirmMessage)));

    this.hideQuickly();
  },

  onYesButton: function onYesButton(event) {
    if (this.mode === SYOSCloseDialogWithUnreservedSeatsMode.RESERVE_SEATS) {
      this.hideQuickly();
      this.syos.reserveSeatsInCart();
    } else {
      this.doCloseDialog();
    }
  },

  onNoButton: function onNoButton(event) {
    if (this.mode === SYOSCloseDialogWithUnreservedSeatsMode.RESERVE_SEATS) {
      this.doCloseDialog();
    } else {
      this.hideQuickly();
    }
  },

  onCancelButton: function onCancelButton(event) {
    this.hideQuickly();
  },

  doCloseDialog: function doCloseDialog() {
    if (window.lDialogs && lDialogs.lastDialog) {
      // LDialog 1 Mode
      lDialogs.lastDialog.shouldClose = function () {
        return true;
      };
      lDialogs.lastDialog.close();
      if (Object.isFunction(this.successCallback)) this.successCallback();
    } else {
      // LDialog 2 Mode
      this.successCallback(true);
    }
  },

  confirm: function confirm(message, event) {
    // console.log(arguments);
    this.triggeredEvent = event.eventName;
    this.successCallback = event.memo;
    this.message.update(message);
    this.show();
  },

  destroy: function destroy($super) {
    this.yesButton.purge();
    this.noButton.purge();
    this.cancelButton.purge();
    $super();
  }

});

var SYOSHeaderBar = Class.create({

  // docHandlers        :: Array
  // mainContainer      :: Div Element
  // currentLabel       :: Div Element
  // backButton         :: Div Element
  // backButtonListener :: Event.Handler

  initialize: function initialize(syos) {

    this.syos = syos;

    this.docHandlers = [document.on(SYOSEvents.HOUSE_DATA_LOADED, this.doHouseDataLoaded.bind(this)), document.on(SYOSEvents.CURR_FLOOR, this.doCurrFloor.bind(this))];

    this.mainContainer = syos.getDisplayElement().down('#syos-header-bar');
    this.currentLabel = this.mainContainer.down('#current-label');
    this.backButton = this.mainContainer.down('#back-button');

    this.backButtonListener = this.backButton.on("click", this.doBackButton.bind(this));
    this.backButtonListener.stop();
  },

  doBackButton: function doBackButton(event) {
    SYOSFloor.currFloor = null;
    document.fire(SYOSEvents.CURR_FLOOR);
  },

  doCurrFloor: function doCurrFloor(event) {

    var currFloor = event.memo instanceof SYOSFloor ? event.memo : null;
    var house = this.syos.getHouseInstance();

    if (currFloor) {
      this.backButtonListener.start();
      this.currentLabel.update(currFloor.getFloorName());
      this.mainContainer.addClassName('viewing-floor');
    } else {
      this.currentLabel.update(house.getName());
      this.backButtonListener.stop();
      this.mainContainer.removeClassName('viewing-floor');
    }
  },

  doHouseDataLoaded: function doHouseDataLoaded(event) {

    var house = this.syos.getHouseInstance(),
        className = 'single-floor-house';

    this.currentLabel.update(house.getName());

    if (house.numFloors === 1) {
      this.mainContainer.addClassName(className);
    } else {
      this.mainContainer.removeClassName(className);
    }
  },

  destroy: function destroy() {

    this.syos = null;

    this.docHandlers.invoke("stop");
    this.docHandlers = null;

    this.backButtonListener.stop();
    this.backButtonListener = null;
  }

});

var SYOSPhotoPreviewSwitch = Class.create({

  // mainContainer :: Div Element
  // switchElement :: Div Element
  // isActive      :: Bool
  // docHandlers   :: Array

  initialize: function initialize(syos, mainContainerSelector) {

    this.syos = syos;

    this.mainContainer = syos.getDisplayElement().down(mainContainerSelector);
    this.switchElement = this.mainContainer.down('#switch');

    this.switchElement.on("click", this.doSwitchClick.bind(this));

    this.docHandlers = [document.on(SYOSEvents.HOUSE_DATA_LOADED, this.checkVisibility.bind(this)), document.on(SYOSEvents.CURR_FLOOR, this.checkVisibility.bind(this)), document.on(SYOSEvents.PHOTO_PREVIEW_TOGGLE, this.doPhotoPreviewToggle.bind(this))];
  },

  checkVisibility: function checkVisibility(event) {
    if (SYOSFloor.currFloor) {
      if (SYOSFloor.currFloor.getPhotoPreviewData().length) {
        this.mainContainer.show();
      } else {
        this.mainContainer.hide();
      }
    } else {
      this.mainContainer.hide();
    }
  },

  doSwitchClick: function doSwitchClick(event, silent) {

    this.isActive = !this.isActive;

    if (this.isActive) {
      this.switchElement.addClassName("active");
    } else {
      this.switchElement.removeClassName("active");
    }

    if (silent !== true) {
      document.fire(SYOSEvents.PHOTO_PREVIEW_TOGGLE, this);
    }
  },

  doPhotoPreviewToggle: function doPhotoPreviewToggle(event) {
    if (event.memo !== this) {
      this.doSwitchClick(event, true);
      // console.log(this);
    }
  },

  destroy: function destroy() {

    this.syos = null;

    this.docHandlers.invoke("stop");
    this.docHandlers = null;

    this.switchElement.purge();
  }

});

var SYOSInfoBar = Class.create({

  // photoPreviewSwitch :: SYOSPhotoPreviewSwitch
  // mainContainer      :: Div Element
  // overviewElement    :: Div Element
  // sectionElement     :: Div Element
  // docHandlers        :: Array

  initialize: function initialize(syos) {

    this.photoPreviewSwitch = new SYOSPhotoPreviewSwitch(syos, '#photo-preview-switch-container');

    this.mainContainer = syos.getDisplayElement().down('#syos-main-info-bar');
    this.overviewElement = this.mainContainer.down('#message-overview');
    this.sectionElement = this.mainContainer.down('#message-seat-view');

    // this.mainContainer      = new Element("div", {id: "syosMainInfoBar"});
    // this.overviewElement    = new Element("div").update("Mouse over and click on a section to select it.");
    // this.sectionElement     = new Element("div").update("Select Your Seats. The black seats are available.").hide();

    // this.mainContainer.insert( this.photoPreviewSwitch.getDisplayElement() );
    // this.mainContainer.insert( this.overviewElement );
    // this.mainContainer.insert( this.sectionElement );

    this.docHandlers = [document.on(SYOSEvents.CURR_FLOOR, this.doCurrFloor.bind(this))];
  },

  // getDisplayElement: function() {
  //   return this.mainContainer;
  // },

  doCurrFloor: function doCurrFloor(event) {

    if (SYOSFloor.currFloor) {
      this.fadeOutAppear(this.overviewElement, this.sectionElement);
    } else {
      this.fadeOutAppear(this.sectionElement, this.overviewElement);
    }
  },

  fadeOutAppear: function fadeOutAppear(elmToFadeOut, elmToAppear) {
    elmToFadeOut.fade({
      duration: 0.25,
      afterFinish: function () {
        elmToAppear.appear({ duration: 0.25 });
      }.bind(this)
    });
  },

  destroy: function destroy() {
    this.photoPreviewSwitch.destroy();
    this.photoPreviewSwitch = null;
    this.docHandlers.invoke("stop");
    this.docHandlers = null;
  }

});

var SYOSSeatInfoDisplay$$1 = Class.create({

  // mainContainer     :: Div Element
  // zoneNameDisplay   :: Div Element
  // pricetypeDisplay  :: Div Element
  // priceDisplay      :: Div Element
  // rowDisplay        :: Div Element
  // seatNumDisplay    :: Div Element
  // seatTypeDisplay   :: Div Element

  // docHandlers       :: Array
  // delayExecuter     :: PeriodicalExecuter

  // syos              :: SYOSMain

  initialize: function initialize(syos, seatView, labelConfig, showSeatInfoDisplay) {

    this.syos = syos;
    this.seatView = seatView;
    this.labelKey = labelConfig.seatInfoDisplay;
    this.priceOutput = labelConfig.seatInfoDisplayPriceOutput;
    this.showSeatInfoDisplay = (showSeatInfoDisplay || function () {}).bind(this);

    this.mainContainer = syos.getDisplayElement().down('#syos-seat-info');
    this.zoneNameDisplay = this.mainContainer.down('#zone-name-display');
    this.pricetypeDisplay = this.mainContainer.down('#pricetype-display');
    this.priceDisplay = this.mainContainer.down('#price-display');
    this.rowDisplay = this.mainContainer.down('#row-display');
    this.seatNumDisplay = this.mainContainer.down('#seat-num-display');
    this.seatTypeDisplay = this.mainContainer.down('#seat-type-display');
    this.seatTypeMessages = this.mainContainer.select('.js-seat-type-message');

    this.docHandlers = [document.on(SYOSEvents.SEAT_ROLL_OVER, this.doSeatRollOver.bind(this)), document.on(SYOSEvents.SEAT_ROLL_OUT, this.doSeatRollOut.bind(this)), document.on(SYOSEvents.SEAT_CLICK, this.doSeatRollOut.bind(this))];

    this.mainContainer.on('mouseover', this.doSeatRollOut.bind(this));
  },

  doSeatRollOver: function doSeatRollOver(event) {

    if (this.delayExecuter) this.delayExecuter.stop();
    this.delayExecuter = new PeriodicalExecuter(this.show.bind(this).curry(event), 0.2);
  },

  show: function show(event, pe) {

    pe.stop();

    /** @type SYOSSeat **/
    var seat = event.memo;

    var mainPricetypeData = this.syos.getMainPricetypeData();
    var zoneDataForSeat = seat.getZoneData();
    var secDataForSeat = seat.getSectionData();

    // Check for an array of pricetype data (otherwise it's an empty string). Should only arise during 'allSeatsMode'
    var hasPricetypeData = zoneDataForSeat.pricetypes instanceof Array;
    var seatMainPricetype = void 0;
    var priceForMainPricetype = 0;

    if (hasPricetypeData) {
      var seatPricetypeForMainPricetype = zoneDataForSeat.pricetypes.detect(function (pricetype) {
        return pricetype.id == mainPricetypeData.id;
      });
      if (seatPricetypeForMainPricetype) {
        priceForMainPricetype = seatPricetypeForMainPricetype.price;
        seatMainPricetype = mainPricetypeData;
      } else {
        // this seat has pricetype data but not for the main pricetype. use the first pricetype
        var firstPricetype = zoneDataForSeat.pricetypes[0];
        priceForMainPricetype = firstPricetype.price;
        seatMainPricetype = this.syos.summaryDataForPricetypeId(firstPricetype.id);
      }
    }

    if (seat.displayMessage) {
      this.seatTypeDisplay.update(seat.displayMessage);
      this.seatTypeDisplay.show();
    } else {
      this.seatTypeDisplay.hide();
    }

    var priceDisplay = void 0;
    var pricetypeDisplay = void 0;

    if (zoneDataForSeat.pricetypes.length > 1 && this.priceOutput === 'priceRange') {

      var allPricetypes = zoneDataForSeat.pricetypes.pluck('price');
      var maximumPrice = Math.max.apply(null, allPricetypes);
      var minimumPrice = Math.min.apply(null, allPricetypes);

      priceDisplay = '$' + minimumPrice.toMoney() + ' - ' + '$' + maximumPrice.toMoney();
      pricetypeDisplay = 'PRICE RANGE';
    } else {

      priceDisplay = "$" + priceForMainPricetype.toMoney();
      pricetypeDisplay = seatMainPricetype.desc;
    }

    this.priceDisplay.update(priceDisplay);

    this.pricetypeDisplay.update(pricetypeDisplay);
    this.zoneNameDisplay.update(this.labelKey === 'zone' ? zoneDataForSeat.name : secDataForSeat.name);
    this.rowDisplay.update(seat.data.row);

    this.seatNumDisplay.update(seat.data.seatNum);
    this.showSeatInfoDisplay(this.syos, seat);

    this.mainContainer.toggleClassName('accessible', !!seat.isAccessible);
    this.displaySeatTypeMessage(seat);

    this.mainContainer.show();
    this.reposition(seat);
  },

  displaySeatTypeMessage: function displaySeatTypeMessage(seat) {
    if (this.seatTypeMessages.length) {
      this.seatTypeMessages.invoke('hide');
      var messageEls = this.seatTypeMessages.filter(function (el) {
        return el.readAttribute('data-seat-type') === seat.displayType;
      });
      messageEls.invoke('show');
    }
  },

  doSeatRollOut: function doSeatRollOut(event) {
    if (this.delayExecuter) this.delayExecuter.stop();
    this.mainContainer.hide();
  },

  getCurrSeatWidth: function getCurrSeatWidth(seatElement) {
    if (this.currSeatWidth) return this.currSeatWidth;
    this.currSeatWidth = seatElement.getWidth();
    return this.currSeatWidth;
  },

  reposition: function reposition(seat) {

    var notchHeight = 0;
    var padding = 5;

    var seatOffset = this.seatView.positionedOffsetForSeat(seat);

    this.mainContainer.setStyle({ left: "0px", top: "0px" });
    var thisDimensions = this.mainContainer.getDimensions();

    var verticalOffset = 10 * SYOSSeatView$$1.SCALE_PERC;
    var targetX = seatOffset.left - thisDimensions.width * 0.5;
    var targetY = seatOffset.top - thisDimensions.height - verticalOffset;

    var fitsRight = targetX + thisDimensions.width < window.innerWidth - SYOSMain.VIEWPORT_OFFSET.left * 2;
    var fitsLeft = targetX > padding;
    var fitsTop = targetY > padding;

    // console.log({fitsLeft: fitsLeft, fitsRight: fitsRight, fitsTop: fitsTop});

    if (!fitsLeft) {
      targetX = padding;
    } else if (!fitsRight) {
      targetX = window.innerWidth - thisDimensions.width - padding - 2 - SYOSMain.VIEWPORT_OFFSET.left * 2;
    }
    if (!fitsTop) {
      targetY = seatOffset.top + verticalOffset;
    }

    this.mainContainer.setStyle({ left: Math.floor(targetX) + "px", top: Math.floor(targetY) + "px" });
  },

  getDisplayElement: function getDisplayElement() {
    return this.mainContainer;
  },

  destroy: function destroy() {

    this.syos = null;
    this.seatView = null;
    this.showSeatInfoDisplay = null;
    this.seatTypeMessages = null;

    this.mainContainer.purge();

    this.docHandlers.invoke("stop");
    this.docHandlers = null;

    if (this.delayExecuter) {
      this.delayExecuter.stop();
      this.delayExecuter = null;
    }
  }

});

var SYOSPricetypeSelector$$1 = Class.create({

  // mainContainer            :: Div Element
  // lineItems                :: Div Element
  // mobileOverlay            :: Div Element
  // summaryContainer         :: Div Element

  // mouseLeaveHandler        :: Event.Handler
  // docHandlers              :: Array

  initialize: function initialize(syos, seatView, labelKey, showPriceTypeSelector) {

    this.syos = syos;
    this.seatView = seatView;

    this.labelKey = labelKey;

    this.mainContainer = syos.getDisplayElement().down('#syos-pricetype-selector');
    this.lineItemTemplate = new Template(this.mainContainer.down('#pricetype-selector-line-item').getValue());
    this.summaryTemplate = new Template(this.mainContainer.down('#pricetype-selector-summary').getValue());
    this.seatTypeMessages = this.mainContainer.select('.js-seat-type-message');

    this.showPriceTypeSelector = (showPriceTypeSelector || function () {}).bind(this);

    this.mobileClose = new Element('div', { 'class': 'pricetype-selector-mobile-close' });
    this.mobileClose.hide();
    this.mobileClose.on('click', this.hide.bind(this));
    this.mobileClose.on('touchstart', this.hide.bind(this));
    this.mainContainer.insert({ before: this.mobileClose });

    this.btnCloseAddtl = this.mainContainer.down('.js-btn-close');
    if (this.btnCloseAddtl) {

      this.btnCloseAddtlHammer = Hammer(this.btnCloseAddtl, {
        drag: false,
        transform: false,
        swipe: false,
        hold: false
      });

      this.btnCloseAddtlHammer.on('tap', this.hide.bind(this));
    }

    // These labels will only be visible if you have add on pricetypes
    this.addOnLabelMainPricetypes = this.mainContainer.down('#pricetype-selector-add-on-label-main-pricetypes') || new Element('div');
    this.addOnLabelAddtlPricetypes = this.mainContainer.down('#pricetype-selector-add-on-label-addtl-pricetypes') || new Element('div');

    this.lineItems = this.mainContainer.down('.line-items');
    this.summaryContainer = this.mainContainer.down('.summary');
    this.seatTypeDisplay = this.mainContainer.down('.seat-type-display');

    this.mouseLeaveHandler = this.mainContainer.down('.syos-popup-body').on("mouseleave", this.hide.bind(this));

    this.docHandlers = [document.on(SYOSEvents.SEAT_CLICK, this.doSeatClick.bind(this))];

    var oldMobileOverlay = this.mainContainer.down('.syos-popup-mobile-overlay');
    if (oldMobileOverlay) {
      // this element is no longer needed - remove if present
      oldMobileOverlay.remove();
    }
  },

  displaySeatTypeMessage: function displaySeatTypeMessage(seat) {
    if (this.seatTypeMessages.length) {
      this.seatTypeMessages.invoke('hide');
      var messageEls = this.seatTypeMessages.filter(function (el) {
        return el.readAttribute('data-seat-type') === seat.displayType;
      });
      messageEls.invoke('show');
    }
  },

  hide: function hide() {
    this.mainContainer.removeClassName('visible');
    this.mobileClose.hide();
  },

  doSeatClick: function doSeatClick(event) {
    var seat = event.memo;
    if (seat.getSelectedPricetypeId()) return;
    var seatPricetypes = seat.getAvailPricetypes();

    var summaryData = this.syos.summaryData;
    var seatCount = this.syos.cart.getSeatCount();

    if (summaryData.maximumTicketCountGlobal && seatCount >= summaryData.maximumTicketCountGlobal) {
      document.fire(SYOSEvents.MAXIMUM_TICKET_COUNT_EXCEEDED);
      return;
    }

    // if (seatPricetypes.length > 1) {
    this.showForSeatAndPricetypes(seat, seatPricetypes);
    // }
  },

  showForSeatAndPricetypes: function showForSeatAndPricetypes(seat, allSeatPricetypes) {

    this.resetDisplay();

    var currCartSeatsByPricetypeId = this.syos.cart.getCartSeatsByPricetypeId(),
        addOnPricetypes = allSeatPricetypes.filter(function (seatPricetype) {
      return !!seatPricetype.nfsAddOn;
    }),
        regPricetypes = allSeatPricetypes.filter(function (seatPricetype) {
      return !seatPricetype.nfsAddOn;
    });

    function createLineItem(seatPricetype) {
      var globalMaxForPricetype = this.syos.maxNumSeatsForPricetypeId(seatPricetype.id);

      var lineItem = new Element('div').update(this.lineItemTemplate.evaluate({
        label: this.syos.summaryDataForPricetypeId(seatPricetype.id).desc,
        price: seatPricetype.price.toMoney()
      }));

      var button = lineItem.down('.syos-button');

      if (globalMaxForPricetype !== 0 && currCartSeatsByPricetypeId[seatPricetype.id] && currCartSeatsByPricetypeId[seatPricetype.id].length >= globalMaxForPricetype) {
        button.update('Maxed').addClassName('disabled');
      } else {
        button.on('click', this.doPricetypeSelected.curry(seat, seatPricetype).bind(this));
      }

      this.lineItems.insert(lineItem.firstDescendant());
    }

    regPricetypes.forEach(createLineItem, this);

    if (addOnPricetypes.length) {
      this.lineItems.insert({ top: this.addOnLabelMainPricetypes });
      this.lineItems.insert(this.addOnLabelAddtlPricetypes);
      addOnPricetypes.forEach(createLineItem, this);
    }

    this.summaryContainer.update(this.summaryTemplate.evaluate({
      seatNum: seat.data.seatNum,
      zoneName: this.labelKey === 'zone' ? seat.getZoneData().name : seat.getSectionData().name,
      row: seat.data.row
    }));

    if (seat.displayMessage) {
      this.seatTypeDisplay.update(seat.displayMessage);
      this.seatTypeDisplay.show();
    } else {
      this.seatTypeDisplay.hide();
    }

    this.mainContainer.toggleClassName('accessible', !!seat.isAccessible);
    this.displaySeatTypeMessage(seat);

    this.showPriceTypeSelector(this.syos, seat);
    this.repositionAboveSeat(seat);
    this.mobileClose.show();
    this.mainContainer.addClassName('visible');
  },

  doPricetypeSelected: function doPricetypeSelected(seat, pricetype, event) {
    seat.setSelectedPricetype(pricetype);
    this.hide();
  },

  repositionAboveSeat: function repositionAboveSeat(seat) {

    var padding = 5;
    var seatOffset = this.seatView.positionedOffsetForSeat(seat);
    this.mainContainer.setStyle({ left: '0px', top: '0px' });

    var thisDimensions = this.mainContainer.getDimensions();

    var targetX = seatOffset.left - thisDimensions.width * 0.5;
    var targetY = seatOffset.top - thisDimensions.height * 0.5;

    var fitsRight = targetX + thisDimensions.width < window.innerWidth - SYOSMain.VIEWPORT_OFFSET.left * 2;
    var fitsLeft = targetX > padding;
    var fitsTop = targetY > padding;
    var fitsBottom = seatOffset.top + SYOSMain.VIEWPORT_OFFSET.top + thisDimensions.height * 0.5 < SYOSMain.STAGE_HEIGHT + this.seatView.canvasOffset.top;

    // console.log({fitsLeft: fitsLeft, fitsRight: fitsRight, fitsTop: fitsTop, fitsBottom: fitsBottom});

    if (!fitsLeft) {
      targetX = padding;
    } else if (!fitsRight) {
      targetX = window.innerWidth - thisDimensions.width - padding - 2 - SYOSMain.VIEWPORT_OFFSET.left * 2;
    }

    if (!fitsBottom) {
      targetY = SYOSMain.STAGE_HEIGHT - padding - thisDimensions.height + this.seatView.canvasOffset.top - SYOSMain.VIEWPORT_OFFSET.top - 2;
      fitsTop = targetY > SYOSMain.VIEWPORT_OFFSET.top;
    }

    if (!fitsTop) {
      targetY = padding;
    }

    this.mainContainer.setStyle({
      left: targetX + 'px',
      top: targetY + 'px'
    });
  },

  resetDisplay: function resetDisplay() {
    this.clearButtons();
    this.lineItems.update('');

    if (this.addOnLabelMainPricetypes.parentNode) {
      this.addOnLabelMainPricetypes.remove();
    }
    if (this.addOnLabelAddtlPricetypes.parentNode) {
      this.addOnLabelAddtlPricetypes.remove();
    }
  },

  clearButtons: function clearButtons() {
    this.lineItems.select('.syos-button').invoke('remove').invoke('purge');
  },

  getDisplayElement: function getDisplayElement() {
    return this.mainContainer;
  },

  destroy: function destroy($super) {

    this.syos = null;
    this.lineItemTemplate = null;
    this.summaryTemplate = null;

    this.clearButtons();

    this.mobileClose.purge();
    this.mobileClose = null;

    if (this.btnCloseAddtl) {
      this.btnCloseAddtl.purge();
      this.btnCloseAddtl = null;

      this.btnCloseAddtlHammer.off('tap');
      this.btnCloseAddtlHammer = null;
    }

    this.mouseLeaveHandler.stop();
    this.mouseLeaveHandler = null;

    this.docHandlers.invoke("stop");
    this.docHandlers = null;
  }

});

var SYOSOverviewDisplay = Class.create({

  // docHandlers              :: Array
  // mainContainer            :: Div Element
  // floorNameDisplay         :: Div Element
  // summaryDisplay           :: Div Element
  // pricetypesContainer      :: Div Element
  // pricetypePricesContainer :: Div Element

  initialize: function initialize(syos) {

    this.syos = syos;
    this.mainContainer = syos.getDisplayElement().down('#syos-overview-display');
    this.floorNameDisplay = this.mainContainer.down('#floor-name-display');
    this.summaryDisplay = this.mainContainer.down('#summary-display');
    this.pricetypesContainer = this.mainContainer.down('#pricetypes');
    this.pricetypePricesContainer = this.mainContainer.down('#prices');

    // this.mainContainer            = new Element("div", {id: "syosOverviewDisplayMainContainer"});
    // this.floorNameDisplay         = new Element("div", {id: "syosOverviewFloorNameDisplay"});
    // this.summaryDisplay             = new Element("div", {id: "syosOverviewSummaryDisplay"});
    // this.pricetypesContainer      = new Element("div", {id: "syosOverviewPricetypesContainer"});
    // this.pricetypePricesContainer = new Element("div", {id: "syosOverviewPricetypePricesContainer"});
    // this.mainContainer.insert(this.floorNameDisplay);
    // this.mainContainer.insert(this.summaryDisplay);
    // this.mainContainer.insert(this.pricetypesContainer);
    // this.mainContainer.insert(this.pricetypePricesContainer);

    this.docHandlers = [document.on(SYOSEvents.FLOOR_ROLL_OVER, this.updateOverview.bind(this)),
    // document.on(SYOSEvents.FLOOR_ROLL_OUT, this.clearOverview.bind(this)),
    // document.on(SYOSEvents.CURR_FLOOR, this.clearOverview.bind(this))
    document.on(SYOSEvents.FLOOR_ROLL_OUT, this.hide.bind(this)), document.on(SYOSEvents.CURR_FLOOR, this.hide.bind(this))];
  },
  // getDisplayElement: function() {
  //   return this.mainContainer;
  // },

  updateOverview: function updateOverview(event) {

    var floor = event.memo;
    var data = floor.getSummaryData();

    this.floorNameDisplay.update(data.floorName);
    this.summaryDisplay.update(this.seatsAvailableText(data));

    if (this.syos.mode === SYOSMode.SEAT_PREVIEW) {

      this.pricetypesContainer.hide();
      this.pricetypePricesContainer.hide();
    } else {

      if (data.avail) {
        this.pricetypesContainer.show().update(data.pricetypeHTML);
        this.pricetypePricesContainer.show().update(data.pricetypePriceHTML);
      } else {
        this.pricetypesContainer.hide();
        this.pricetypePricesContainer.hide();
      }
    }

    this.show();
  },

  seatsAvailableText: function seatsAvailableText(data) {

    if (this.syos.mode === SYOSMode.SEAT_PREVIEW) {
      var val = data.total + " total seats";
      if (data.numFrontLoadedSeats) {
        return data.numFrontLoadedSeats + ' ' + (data.numFrontLoadedSeats > 1 ? 'seats' : 'seat') + ' selected' + '<br><br>' + val;
      } else {
        return val;
      }
    } else {
      if (data.avail) {
        return data.avail + " of " + data.total + " seats available";
      } else {
        return SYOSMessage$$1.applyTemplate(SYOSMessageTemplates.labelFloorSoldOut);
      }
    }
  },

  hide: function hide() {
    // setTimeout(function(){
    this.mainContainer.hide();
    // }.bind(this), 0);
  },
  show: function show() {
    this.mainContainer.show();
  },

  // clearOverview: function(event) {
  //   this.floorNameDisplay.update("");
  //   this.summaryDisplay.update("");
  //   this.pricetypesContainer.update("");
  //   this.pricetypePricesContainer.update("");
  // },

  destroy: function destroy() {

    this.syos = null;

    this.docHandlers.invoke("stop");
    this.docHandlers = null;
  }

});

var SYOSLegend = Class.create({

  initialize: function initialize(syos) {

    var legend = syos.getDisplayElement().down('#syos-legend');
    var legendPricetypes = legend.down('.pricetypes');
    var legendSeatTypes = new Element('div', { 'class': 'seat-types' });
    var legendPricetypesTemplate = new Template(legendPricetypes.down('#pricetypes-legend-template').getValue());
    var mobileButton = syos.getDisplayElement().down('#syos-legend-mobile-button');
    var mobileContents = syos.getDisplayElement().down('#syos-legend-mobile-contents');
    var mobileContentsOverlay = mobileContents.down('.syos-popup-mobile-overlay');
    var samePriceItem = legend.down('.item.same-price');

    this.syos = syos;
    this.legend = legend;
    this.mobileButton = mobileButton;
    this.mobileContents = mobileContents;
    this.mobileContentsOverlay = mobileContentsOverlay;
    this.legendPricetypes = legendPricetypes;
    this.legendSeatTypes = legendSeatTypes;
    this.legendPricetypesTemplate = legendPricetypesTemplate;
    this.samePriceItem = samePriceItem;

    this.mobileButton.on('click', this.doMobileButtonClick.bind(this));
    this.mobileContentsOverlay.on('click', this.doOverlayClick.bind(this));

    legendPricetypes.insert({ before: legendSeatTypes });

    this.docHandlers = [document.on(SYOSEvents.SEAT_DATA_LOADED, this.doSeatDataLoaded.bind(this))];
  },

  setSeatTypeIcons: function setSeatTypeIcons(data) {
    var _this = this;

    this.legendSeatTypes.update('');

    $H(data).each(function (o) {
      var div = new Element('div');
      div.insert('\n<div class="item">\n  <div style="width: 25px; height: 25px; padding-top: 10px;  margin-top: -10px; margin-bottom: -8px;" class="seat seat-type-icon"></div>\n  <div class="label" style="margin-bottom: 10px;">' + o.key + '</div>\n</div>');

      var iconContainer = div.down('.seat-type-icon');
      iconContainer.insert(o.value);

      _this.legendSeatTypes.insert(div);
    });

    this.updateMobileDisplay();
  },
  updateMobileDisplay: function updateMobileDisplay() {
    this.mobileContents.down('.duped-content').update(this.legend.innerHTML);
  },


  setHouseLegendData: function setHouseLegendData(legendData) {

    legendData = legendData || {};

    this.legendPricetypes.update('');

    $H(legendData).each(function (o) {
      this.legendPricetypes.insert(this.legendPricetypesTemplate.evaluate({
        hex: o.value,
        label: o.key
      }));
    }, this);

    this.updateMobileDisplay();
  },

  doSeatDataLoaded: function doSeatDataLoaded(event) {
    if (this.samePriceItem) {
      if (this.syos.seatView.highlightSamePrice) {
        this.samePriceItem.show();
      } else {
        this.samePriceItem.hide();
      }
    }
  },

  doMobileButtonClick: function doMobileButtonClick(event) {
    this.mobileContents.addClassName('visible');
  },
  doOverlayClick: function doOverlayClick(event) {
    this.mobileContents.removeClassName('visible');
  },

  destroy: function destroy() {

    this.docHandlers.each(function (handler) {
      handler.stop();
    });
    this.docHandlers = null;

    this.mobileButton.purge();
    this.mobileContentsOverlay.purge();
  }
});

var SYOSErrors = {
  SYOSINFO_PARSE_ERROR: 1,
  SYOSINFO_NO_ALTERNATES: 2,
  SYOSINFO_EXCEPTION: 3,
  HOUSE_CONFIG_PARSE_ERROR: 4,
  HOUSE_CONFIG_EXCEPTION: 5,
  SYOSSUMMARY_PARSE_ERROR: 6,
  SYOSSUMMARY_NO_PRICETYPES: 7,
  SYOSSUMMARY_EXCEPTION: 8,
  SYOSSECTION_PARSE_ERROR: 9,
  SYOSSECTION_EXCEPTION: 10,
  SYOSRESERVESEATS_PARSE_ERROR: 11,
  SYOSRESERVESEATS_EXCEPTION: 12,
  SYOSHOUSE_SVG_EXCEPTION: 13,
  SYOSINFO_NOT_FOUND: 14,
  HOUSE_CONFIG_NOT_FOUND: 15,
  SYOSSUMMARY_NOT_FOUND: 16,
  SYOSSECTION_NOT_FOUND: 17,
  SYOSRESERVESEATS_NOT_FOUND: 18,
  SYOSHOUSE_SVG_NOT_FOUND: 19
};

var SYOSErrorOverlay = Class.create(SYOSOverlay, {

  initialize: function initialize($super, syos, errorCode, requestedURL) {

    errorCode = errorCode || 0;

    $super(syos, '#syos-error-overlay');

    syos.interstitialOverlay.hideQuickly();
    syos.alertOverlay.hideQuickly();

    this.message.update(SYOSMessage$$1.applyTemplate(SYOSMessageTemplates.genericError));
    this.show();

    new Ajax.Request(syos.logErrorURL, {
      parameters: core.Object.assign({
        location: document.location.href,
        requestedURL: requestedURL,
        errorCode: errorCode
      }, syos.getAjaxParams())
    });
  }

});

// STATIC VARS
// STAGE_WIDTH  :: int
// STAGE_HEIGHT :: int

var SYOSMain = Class.create({

  // syosMainContainer   :: Div Element
  // syosContainer       :: Div Element
  // baseURL             :: String
  // typeId              :: String
  // houseId             :: String
  // houseDataBaseURL    :: String
  // summaryDataURL      :: String
  // infoDataURL         :: String
  // reserveSeatsURL     :: String
  // modulePath          :: String
  // docHandlers         :: Array
  // summaryData         :: Object
  // infoDataLoaded      :: Bool
  // houseDataLoaded     :: Bool
  // summaryDataLoaded   :: Bool
  // addtlParams         :: Object

  // infoRequest         :: Ajax.Request
  // houseDataRequest    :: Ajax.Request
  // summaryRequest      :: Ajax.Request
  // seatDataRequest     :: Ajax.Request
  // seatAvailRequest    :: Ajax.Request

  // dateSwitch          :: SYOSDateSwitch
  // pricetypeSelector   :: SYOSPricetypeSelector
  // cart                :: SYOSCart
  // interstitialOverlay :: SYOSInterstitialOverlay
  // alertOverlay        :: SYOSAlert
  // headerBar           :: SYOSHeaderBar
  // seatInfoDisplay     :: SYOSSeatInfoDisplay
  // photoPreview        :: SYOSPhotoPreview
  // infoBar             :: SYOSInfoBar
  // seatView            :: SYOSSeatView
  // house               :: SYOSHouse


  initialize: function initialize(o) {

    o = o || {};

    if (!SYOSMain.isBrowserSupported) {
      alert('SYOS not supported in this browser.');
    }

    this.initMetaViewport();

    /*
    o = {
      syosMainContainer   :: id String or Element, defaults to 'syos-main-container'
      pId                 :: int
      typeId              :: String
      houseId             :: String
      plotMode            :: Bool, optional
      allSeatsMode        :: Bool, optional
      baseURL             :: String, optional
      houseDataBaseURL    :: String, optional
      logErrorURL         :: String, optional
      addtlParams         :: Object, optional
      siteCartModule      :: String, optional ('cart' or 'tessitura')
      loadTestData        :: Boolean, optional
      cacheId             :: String, optional
       // The below items are deprecated in favor of 'loadTestData'
      summaryDataURL      :: String, optional
      infoDataURL         :: String, optional
      reserveSeatsURL     :: String, optional
      sectionDataURL      :: String, optional
      loadTestSectionData :: Boolean, optional
     }
    */

    this.hasErrored = false;

    this.baseURL = o.baseURL || '';
    this.pId = o.pId || 999;
    this.syosMainContainer = $(o.syosMainContainer || 'syos-main-container');
    this.typeId = o.typeId ? o.typeId.toLowerCase() : 'perf';
    this.houseId = o.houseId;
    this.mode = o.mode || SYOSMode.STANDARD;
    this.cacheId = o.cacheId || '0';

    var siteCartModule = o.siteCartModule || 'cart';
    this.siteCartModule = siteCartModule;

    this.summaryDataURL = o.summaryDataURL;
    this.infoDataURL = o.infoDataURL;
    this.sectionDataURL = o.sectionDataURL;

    this.reserveSeatsURL = o.reserveSeatsURL;

    this.loadTestSectionData = !!o.loadTestSectionData;
    this.loadSoldOutFloors = !!o.loadSoldOutFloors;

    this.loadTestData = !!o.loadTestData;

    this.logErrorURL = o.logErrorURL || '/h/' + siteCartModule + '/SyosLogError';
    this.addtlParams = o.addtlParams || {};
    SYOSHouse.houseDisplayNames = o.houseDisplayNames;

    this.modulePath = window.pRube ? window.pRube.modulePath : "/modules/";
    this.houseDataBaseURL = o.houseDataBaseURL || this.modulePath + "syos_local/houseData/";

    this.viewport = this.syosMainContainer.down('#syos-viewport');
    this.headerBarEl = this.syosMainContainer.down('#new-syos-header-give-this-a-new-name');

    this.onSeatAvailRequestSuccess = o.onSeatAvailRequestSuccess;

    this.docHandlers = [Event.on(window, 'resize', this.onResize.bind(this)), document.on(SYOSEvents.CURR_FLOOR, this.doCurrFloor.bind(this)), document.on(SYOSEvents.HOUSE_DATA_LOADED, this.onHouseDataLoaded.bind(this))];

    this.dateSwitch = new SYOSDateSwitch(this, this.pId, this.typeId, o.dateSwitchTemplateString);
    this.cart = new SYOSCart$$1(this, { cartSeatGrouping: o.cartSeatGrouping });
    this.interstitialOverlay = new SYOSInterstitialOverlay(this);
    this.alertOverlay = new SYOSAlert(this);
    this.confirmOverlay = new SYOSConfirmOverlay(this, o.closeDialogWithUnreservedSeatsMode);
    this.headerBar = new SYOSHeaderBar(this);
    this.infoBar = new SYOSInfoBar(this);
    this.legend = new SYOSLegend(this);
    this.seatView = new SYOSSeatView$$1(this, this.cart, this.pricetypeSelector, this.legend, {
      allSeatsMode: o.allSeatsMode,
      highlightSamePrice: o.highlightSamePrice || o.highlightSameZones,
      alwaysHighlightSamePrice: o.alwaysHighlightSamePrice
    });
    var labelConfig = this.getLabelConfig(o.labelConfig, o.useZoneNames);
    this.scrollContainerEl = o.scrollContainerEl || '.l-dialog';

    this.seatInfoDisplay = new SYOSSeatInfoDisplay$$1(this, this.seatView, labelConfig, o.showSeatInfoDisplay);
    this.pricetypeSelector = new SYOSPricetypeSelector$$1(this, this.seatView, labelConfig.pricetypeSelector, o.showPriceTypeSelector);

    this.mobilePhotoPreviewSwitch = new SYOSPhotoPreviewSwitch(this, '#photo-preview-switch-container-mobile');

    this.overviewDisplay = new SYOSOverviewDisplay(this);

    if (this.mode === SYOSMode.SEAT_PREVIEW) {
      this.syosMainContainer.addClassName('syos-mode-seat-preview');
    }

    this.loadInfo();
    this.loadHouseData();
    this.loadSummaryData();

    this.onResize.bind(this).defer();

    SYOSMain.instance = this;
  },

  getLabelConfig: function getLabelConfig(userConfig, useZoneNames) {
    userConfig = userConfig || {};

    var defaultConfig = {
      pricetypeSelector: 'section', // zone || section
      seatInfoDisplay: 'zone', // zone || section
      seatInfoDisplayPriceOutput: 'firstPrice' // firstPrice || priceRange
    };

    if (useZoneNames) {
      // deprecated - gets overridden by 'userConfig'

      defaultConfig.pricetypeSelector = 'zone';
      defaultConfig.seatInfoDisplay = 'zone';
    }

    return core.Object.assign(defaultConfig, userConfig);
  },

  getSummaryURL: function getSummaryURL() {
    var url = void 0;
    if (this.summaryDataURL) {
      url = this.summaryDataURL;
    } else if (this.loadTestData) {
      url = 'testData/summaryData-' + this.getHouseId() + '.json';
    } else {
      url = '/h/' + this.siteCartModule + '/SyosSummary';
    }
    return url;
  },
  getInfoDataURL: function getInfoDataURL() {
    var url = void 0;
    if (this.infoDataURL) {
      url = this.infoDataURL;
    } else if (this.loadTestData) {
      url = 'testData/infoData.json';
    } else {
      url = '/h/' + this.siteCartModule + '/SyosInfo';
    }
    return url;
  },
  getSectionDataURL: function getSectionDataURL() {
    var url = void 0;
    if (this.loadTestSectionData || this.loadTestData) {
      url = 'testData/sectionData-' + this.getHouseId() + '-floor' + SYOSFloor.currFloor.data.floorNum + '.json';
    } else {
      url = '/h/' + this.siteCartModule + '/SyosSection';
    }
    return url;
  },
  getHouseDataURL: function getHouseDataURL() {
    return this.houseDataBaseURL + this.getHouseId() + '.json?cache=' + this.cacheId;
  },
  getReserveSeatsURL: function getReserveSeatsURL() {
    var url = void 0;
    if (this.reserveSeatsURL) {
      url = this.reserveSeatsURL;
    } else if (this.loadTestData) {
      url = 'testData/reserveSeatsData.json';
    } else {
      url = '/h/' + this.siteCartModule + '/SyosReserveSeats';
    }
    return url;
  },

  onResize: function onResize(event) {
    var docViewportHeight = window.innerHeight || document.viewport.getHeight();
    var headerHeight = this.headerBarEl.getHeight();
    var footerHeight = 0;
    var mainContainerOffset = this.syosMainContainer.viewportOffset();
    var mainContainerLayout = this.syosMainContainer.getLayout();
    var viewportHeight = docViewportHeight - headerHeight - footerHeight - mainContainerOffset.top * 2 - mainContainerLayout.get('border-top') - mainContainerLayout.get('border-bottom');

    SYOSMain.PREV_STAGE_WIDTH = SYOSMain.STAGE_WIDTH;
    SYOSMain.PREV_STAGE_HEIGHT = SYOSMain.STAGE_HEIGHT;

    SYOSMain.STAGE_WIDTH = mainContainerLayout.get('width');
    SYOSMain.STAGE_HEIGHT = viewportHeight;
    SYOSMain.VIEWPORT_OFFSET = {
      left: mainContainerOffset.left,
      top: mainContainerOffset.top
    };

    this.viewport.setStyle({ 'height': SYOSMain.STAGE_HEIGHT + 'px' });

    document.fire(SYOSEvents.RESIZE);
  },

  getDisplayElement: function getDisplayElement() {
    return this.syosMainContainer;
  },

  getHouseId: function getHouseId() {
    return this.houseId;
  },

  getHouseInstance: function getHouseInstance() {
    return this.house;
  },

  getAjaxParams: function getAjaxParams() {
    var o = core.Object.assign({
      houseid: this.getHouseId(),
      id: this.pId,
      type: this.typeId
    }, this.addtlParams);

    if (this.mode === SYOSMode.SEAT_PREVIEW) {
      o.syosmode = 'seatpreview';
    }

    return o;
  },

  onAjaxError: function onAjaxError(errorCode, requester, exception) {
    console.log(requester);
    console.log(exception.message);
    var requestedURL = requester.request ? requester.request.url : requester.url; // onFailure passes in a response object object, onException passes in a request object
    new SYOSErrorOverlay(this, errorCode, requestedURL);
    this.hasErrored = true;
  },

  validateAjaxResponseJSON: function validateAjaxResponseJSON(response, errorCode) {
    if (!response.responseJSON) {
      try {
        response.responseJSON = response.responseText.evalJSON();
      } catch (error) {
        new SYOSErrorOverlay(this, errorCode, response.request.url);
        return false;
      }
    }
    return true;
  },

  loadInfo: function loadInfo() {
    var _this = this;

    this.infoDataLoaded = false;

    var onComplete = function onComplete(response) {
      _this.infoRequest = null;
    };

    this.infoRequest = new Ajax.Request(this.getInfoDataURL(), {
      parameters: this.getAjaxParams(),
      method: "get",
      onSuccess: function (response) {

        if (!this.validateAjaxResponseJSON(response, SYOSErrors.SYOSINFO_PARSE_ERROR)) return;

        if (!response.responseJSON.alternates) {
          new SYOSErrorOverlay(this, SYOSErrors.SYOSINFO_NO_ALTERNATES, response.request.url);
          return;
        }

        this.dateSwitch.setData(response.responseJSON);

        this.infoDataLoaded = true;
        this.checkInitDataLoadStatus();
        document.fire(SYOSEvents.INFO_DATA_LOADED);
      }.bind(this), onException: this.onAjaxError.bind(this, SYOSErrors.SYOSINFO_EXCEPTION),

      onFailure: this.onAjaxError.bind(this, SYOSErrors.SYOSINFO_NOT_FOUND),
      onComplete: onComplete
    });
  },

  loadHouseData: function loadHouseData() {

    this.houseDataLoaded = false;

    this.cart.removeAllSeats();

    if (this.house) {
      this.house.destroy();
      this.house = null;
    }

    this.houseDataRequest = new Ajax.Request(this.getHouseDataURL(), {
      method: "get",
      onSuccess: function (response) {

        if (!this.validateAjaxResponseJSON(response, SYOSErrors.HOUSE_CONFIG_PARSE_ERROR)) return;

        var houseData = response.responseJSON;

        houseData.houseId = this.getHouseId();

        SYOSSeatIcons.updateIconStateColors(houseData.seatHexCodes);
        this.legend.setHouseLegendData(houseData.legend);
        this.house = new SYOSHouse(houseData, this);
      }.bind(this),
      onException: this.onAjaxError.bind(this, SYOSErrors.HOUSE_CONFIG_EXCEPTION),
      onFailure: this.onAjaxError.bind(this, SYOSErrors.HOUSE_CONFIG_NOT_FOUND),
      onComplete: function (response) {

        this.houseDataRequest = null;
      }.bind(this)
    });
  },

  onHouseDataLoaded: function onHouseDataLoaded(event) {
    this.houseDataLoaded = true;
    this.checkInitDataLoadStatus();
  },

  reload: function reload() {
    this.setPIdForHouse(this.pId, this.houseId);
  },

  setPIdForHouse: function setPIdForHouse(pId, houseId) {

    this.pId = pId;

    if (houseId != this.getHouseId()) {

      if (SYOSFloor.currFloor) {
        SYOSFloor.currFloor = null;
        document.fire(SYOSEvents.CURR_FLOOR);
      }

      this.houseId = houseId;
      this.loadHouseData();

      var summaryDataLoadedHandler = document.on(SYOSEvents.SUMMARY_DATA_LOADED, function (event) {
        summaryDataLoadedHandler.stop();

        this.docHandlers = this.docHandlers.without(summaryDataLoadedHandler);
      }.bind(this));
      this.docHandlers.push(summaryDataLoadedHandler);

      this.loadSummaryData();
      document.fire(SYOSEvents.VENUE_CHANGE);
    } else {
      this.loadSummaryData();
    }
  },

  loadSummaryData: function loadSummaryData() {

    this.summaryDataLoaded = false;

    document.fire(SYOSEvents.SUMMARY_DATA_LOAD_BEGIN);

    this.summaryRequest = new Ajax.Request(this.getSummaryURL(), {
      parameters: this.getAjaxParams(),
      method: "get",
      onSuccess: function (response) {

        if (!this.validateAjaxResponseJSON(response, SYOSErrors.SYOSSUMMARY_PARSE_ERROR)) return;

        this.summaryData = response.responseJSON;
        if (!this.summaryData.frontLoadedSeats) {
          this.summaryData.frontLoadedSeats = [];
        }

        var index = 0;

        if (this.summaryData.pricetypes) {

          this.summaryData.pricetypes.each(function (pricetype) {
            pricetype.order = index;
            index++;
          });
        } else {

          new SYOSErrorOverlay(this, SYOSErrors.SYOSSUMMARY_NO_PRICETYPES, response.request.url);
          return;
        }

        var resolveDisplayType = function resolveDisplayType(data) {
          var displayType = void 0;

          if (typeof data.displayAsStandard !== 'undefined') {
            // legacy pre-displayType setup
            displayType = data.displayAsStandard ? DisplayTypes.STANDARD : DisplayTypes.DONUT;
          } else {
            displayType = data.displayType;
          }

          return displayType;
        };

        ['seatTypes', 'holdCodes'].each(function (key) {
          var data = {};
          var source = this.summaryData[key];
          if (source) {
            source.each(function (o) {
              data[o.id] = {
                label: o.label,
                displayType: resolveDisplayType(o),
                isAccessible: !!o.isAccessible
              };
            });
          }
          SYOSMain[key] = data;
        }, this);

        this.summaryDataLoaded = true;
        this.checkInitDataLoadStatus();

        document.fire(SYOSEvents.SUMMARY_DATA_LOADED);
      }.bind(this),
      onException: this.onAjaxError.bind(this, SYOSErrors.SYOSSUMMARY_EXCEPTION),
      onFailure: this.onAjaxError.bind(this, SYOSErrors.SYOSSUMMARY_NOT_FOUND),
      onComplete: function (response) {

        this.summaryRequest = null;
      }.bind(this)
    });
  },

  getFrontLoadedSeatIds: function getFrontLoadedSeatIds() {
    return this.summaryData.frontLoadedSeats.pluck('seatId');
  }, checkInitDataLoadStatus: function checkInitDataLoadStatus() {

    if (this.houseDataLoaded && this.infoDataLoaded && this.summaryDataLoaded) {

      this.house.updateSummaryData(this.summaryData);

      if (this.summaryData.frontLoadedSeats.length && !this.frontLoadedSeatsLoaded) {

        this.frontLoadedSeatsLoaded = true;

        var seats = [];

        this.summaryData.frontLoadedSeats.each(function (data) {
          data.isAvailable = true; /* Front loaded seats are always available? */
          var seat = new SYOSSeat$$1(this, this.seatView, this.house, data, this.seatView.allSeatsMode);
          seat.isFrontLoaded = true;
          var seatPricetypes = this.summaryDataForZoneId(data.zoneNum).pricetypes;
          var selectedPricetype = seatPricetypes.detect(function (pricetype) {
            return pricetype.id === data.pricetype;
          });
          if (selectedPricetype) {
            seat._selectedPricetype = selectedPricetype;
          }

          seats.push(seat);
        }, this);

        // sort so non-addon seats display first
        seats.sort(function (a, b) {

          var aIsNFS = a._selectedPricetype && a._selectedPricetype.nfsAddOn;
          var bIsNFS = b._selectedPricetype && b._selectedPricetype.nfsAddOn;

          if (!aIsNFS && bIsNFS) {
            return -1;
          } else if (aIsNFS && !bIsNFS) {
            return 1;
          } else {
            return 0;
          }
        });

        seats.each(function (seat) {
          if (seat._selectedPricetype) {
            seat.setSelectedPricetype(seat._selectedPricetype);
            seat._selectedPricetype = null;
          }
        }, this);
      }

      if (!SYOSFloor.currFloor) {
        document.fire(SYOSEvents.SYOS_READY);
      }

      switch (true) {
        case this.house.numFloors === 1:
          this.house.floors[0].selectFloor();
          break;

        case !!SYOSFloor.currFloor:
          this.loadCurrFloorData();
          break;

        case this.mode === SYOSMode.SEAT_PREVIEW:

          // Let the floors know how many front loaded seats they have

          var frontLoadedSeats = this.summaryData.frontLoadedSeats;
          if (frontLoadedSeats.length) {

            var firstFloor = void 0;

            frontLoadedSeats.each(function (seat) {
              var secNum = this.summaryDataForZoneId(seat.zoneNum).sections[0].id;
              var floor = this.getFloorForSectionNumber(secNum);

              if (!firstFloor) firstFloor = floor;
              if (!floor.numFrontLoadedSeats) floor.numFrontLoadedSeats = 0;

              floor.numFrontLoadedSeats += 1;
            }, this);

            if (firstFloor) {
              this.house.fadeOutHouse();
              setTimeout(function () {
                firstFloor.selectFloor();
              }, 0);
            }
          }

          break;
      }
    }
    if (window.LDialog) window.LDialog.resize();
  },

  loadCurrFloorData: function loadCurrFloorData() {

    document.fire(SYOSEvents.SEAT_DATA_LOAD_BEGIN);

    this.seatDataRequest = new Ajax.Request(this.getSectionDataURL(), {
      parameters: core.Object.assign({
        section: SYOSFloor.currFloor.getSections().join(","),
        geo: 1
      }, this.getAjaxParams()),
      method: "get",
      onSuccess: function (response) {

        if (!this.validateAjaxResponseJSON(response, SYOSErrors.SYOSSECTION_PARSE_ERROR)) return;

        this.onResize();
        this.seatView.buildOutSeatsForFloor(response.responseJSON.seats, SYOSFloor.currFloor); // document.fire(SYOSEvents.SEAT_DATA_LOADED); // seatview fires this when it's ready to render now
      }.bind(this),
      onException: this.onAjaxError.bind(this, SYOSErrors.SYOSSECTION_EXCEPTION),
      onFailure: this.onAjaxError.bind(this, SYOSErrors.SYOSSECTION_NOT_FOUND),
      onComplete: function (response) {
        this.seatDataRequest = null;
      }.bind(this)
    });
  },

  reserveSeatsInCart: function reserveSeatsInCart() {
    var seats = this.cart.getCartSeatsByPricetypeId();
    var flattenedSeats = core.Object.values(seats).flatten();
    if (flattenedSeats.length) {
      this.checkAvailForSeats(seats);
    }
  },

  checkAvailForSeats: function checkAvailForSeats(seats) {

    var flattenedSeats = core.Object.values(seats).flatten();
    var missingSeatsForPricetypes = this.summaryData.pricetypes.filter(function (pricetype) {
      var minSeats = this.minNumSeatsForPricetypeId(pricetype.id);
      var seatsForPricetype = seats[pricetype.id];
      if (pricetype.required) {
        return !seatsForPricetype || seatsForPricetype.length < minSeats;
      } else {
        return minSeats && seatsForPricetype && seatsForPricetype.length < minSeats;
      }
    }, this);

    if (missingSeatsForPricetypes.length) {
      document.fire(SYOSEvents.MINIMUM_SEATS_FOR_PRICETYPES_NOT_ACQUIRED);
      return;
    }

    var invalidGroupedTickets = this.summaryData.pricetypes.filter(function (pricetype) {
      if (pricetype.groupedTickets) {
        var seatsForPricetype = seats[pricetype.id];
        return seatsForPricetype && seatsForPricetype.length % pricetype.groupedTickets !== 0;
      } else {
        return false;
      }
    }, this);

    if (invalidGroupedTickets.length) {
      var pricetype = invalidGroupedTickets[0];
      document.fire(SYOSEvents.RESERVE_INVALID_GROUPED_TICKETS, {
        pricetypeName: pricetype.desc,
        labelRequiredIn: pricetype.groupedTickets === 2 ? 'pairs' : 'sets',
        groupedTickets: pricetype.groupedTickets,
        currSelectedCount: seats[pricetype.id].length
      });
      return;
    }

    if (this.summaryData.requireExactTicketCountGlobal && flattenedSeats.length !== this.summaryData.requireExactTicketCountGlobal) {
      document.fire(SYOSEvents.EXACT_TICKET_COUNT_MISMATCH);
      return;
    }

    var addOnPricetypes = this.summaryData.pricetypes.filter(function (seatPricetype) {
      return !!seatPricetype.nfsAddOn;
    });

    var regPricetypes = this.summaryData.pricetypes.filter(function (seatPricetype) {
      return !seatPricetype.nfsAddOn;
    });

    var addOnPricetypesOb = addOnPricetypes.reduce(function (o, v) {
      o[v.id] = true;
      return o;
    }, {});

    var regPricetypesOb = regPricetypes.reduce(function (o, v) {
      o[v.id] = true;
      return o;
    }, {});

    var regSeats = flattenedSeats.filter(function (seat) {
      return !!regPricetypesOb[seat.selectedPricetype.id];
    });
    var addOnSeats = flattenedSeats.filter(function (seat) {
      return !!addOnPricetypesOb[seat.selectedPricetype.id];
    });

    var data = core.Object.assign({
      seats: regSeats.invoke('getReserveSeatsData'),
      nfsAddOns: addOnSeats.invoke('getReserveSeatsData')
    }, this.getAjaxParams());

    document.fire(SYOSEvents.SEAT_AVAIL_CHECK_BEGIN);

    this.seatAvailRequest = new Ajax.Request(this.getReserveSeatsURL(), {
      method: 'post',
      postBody: Object.toJSON(data),
      onSuccess: function (response) {

        if (!this.validateAjaxResponseJSON(response, SYOSErrors.SYOSRESERVESEATS_PARSE_ERROR)) return;

        var data = response.responseJSON;

        if (data.success) {

          if (this.onSeatAvailRequestSuccess) {
            // Cleanup after yourself!
            // If you're not leaving the page make sure the syos instance is destroyed
            this.onSeatAvailRequestSuccess(this, data);
            return;
          }

          document.fire(SYOSEvents.SEAT_AVAIL_CHECK_SUCCESS, data);

          if (data.erubeJSHandler) {

            lDialogs.lastDialog.shouldClose = function () {
              return true;
            };

            eRube.submit({
              url: data.erubeJSHandler,
              parameters: this.getAjaxParams()
            });
          } else {
            window.location.href = data.viewCartLink || window.location.href;
          }
        } else if (data.retainState === true && data.displayMessage) {

          document.fire(SYOSEvents.SEAT_AVAIL_CHECK_SUCCESS, data);
          this.alertOverlay.alert(data.displayMessage);
        } else {
          document.fire(SYOSEvents.SEAT_AVAIL_CHECK_FAIL);
          this.loadSummaryData();
        }
      }.bind(this),
      onException: this.onAjaxError.bind(this, SYOSErrors.SYOSRESERVESEATS_EXCEPTION),
      onFailure: this.onAjaxError.bind(this, SYOSErrors.SYOSRESERVESEATS_NOT_FOUND),
      onComplete: function (response) {

        this.seatAvailRequest = null;
      }.bind(this)

    });
  },

  getFloorForSectionNumber: function getFloorForSectionNumber(secNum) {
    return this.house.floors.detect(function (floor) {
      return floor.data.secs.indexOf(secNum) !== -1;
    });
  },

  doCurrFloor: function doCurrFloor(event) {

    if (SYOSFloor.currFloor) {
      var container = $$(this.scrollContainerEl);
      if (container.length) {
        container[0].scrollTop = 0;
      }

      window.scrollTo(0, 0);
    }

    this.updateModeClasses();
    this.onResize();

    if (SYOSFloor.currFloor) {
      this.loadCurrFloorData();
    }
  },

  updateModeClasses: function updateModeClasses() {
    if (SYOSFloor.currFloor) {
      this.syosMainContainer.addClassName('seat-view');this.syosMainContainer.removeClassName('overview');
    } else {
      this.syosMainContainer.addClassName('overview');
      this.syosMainContainer.removeClassName('seat-view');
    }
  },

  getMainPricetypeData: function getMainPricetypeData() {
    return this.summaryData.pricetypes[0];
  },
  getPricetypeSelector: function getPricetypeSelector() {
    return this.pricetypeSelector;
  },

  summaryDataForSectionNum: function summaryDataForSectionNum(sectionId) {
    var val = this.summaryData.sections.detect(function (n) {
      return n.id == sectionId;
    });
    if (!val) {
      throw new Error('No Section Data for sectionId ' + sectionId);
    }
    return val;
  },
  summaryDataForZoneId: function summaryDataForZoneId(zoneId) {
    var val = this.summaryData.zones.detect(function (n) {
      return n.id == zoneId;
    });

    if (!val) {
      throw new Error('No Zone Data for zoneId ' + zoneId);
    }
    return val;
  },
  summaryDataForPricetypeId: function summaryDataForPricetypeId(pricetypeId) {
    var val = this.summaryData.pricetypes.detect(function (n) {
      return n.id == pricetypeId;
    });
    if (!val) {
      throw new Error('No Pricetype Data for pricetypeId ' + pricetypeId);
    }
    return val;
  },

  maxNumSeatsForPricetypeId: function maxNumSeatsForPricetypeId(pricetypeId) {
    return this.summaryDataForPricetypeId(pricetypeId).max || 0;
  },

  minNumSeatsForPricetypeId: function minNumSeatsForPricetypeId(pricetypeId) {
    return this.summaryDataForPricetypeId(pricetypeId).min || 0;
  },

  abortRequest: function abortRequest(request) {
    if (request) request.transport.abort();
  },

  openCart: function openCart() {
    this.syosMainContainer.addClassName('cart-open');
  },
  closeCart: function closeCart() {
    this.syosMainContainer.removeClassName('cart-open');
  },

  initMetaViewport: function initMetaViewport() {
    var metas = $$('meta[name=viewport]');
    var requiredContent = 'width = device-width, user-scalable = no, minimum-scale = 1, maximum-scale = 1';
    this.preexistingMetaContent = '';
    if (metas.length) {
      var meta = metas[0];
      this.preexistingMetaContent = meta.readAttribute('content');
      meta.writeAttribute('content', requiredContent);
    } else {

      try {
        console.warn('SYOS requires site to have meta viewport tag defined. Creating one now.');
      } catch (e) {}

      $$('head')[0].insert(new Element('meta', { name: 'viewport', content: requiredContent }));
    }
  },

  resetMetaViewport: function resetMetaViewport() {
    var metas = $$('meta[name=viewport]');
    if (metas.length) {
      metas[0].writeAttribute('content', this.preexistingMetaContent);
    }
  },

  showDialogCloseButton: function showDialogCloseButton() {
    try {
      lDialog.removeClass('l-dialog-syos-hide-close-btn');
    } catch (e) {}
  },
  hideDialogCloseButton: function hideDialogCloseButton() {
    try {
      lDialog.addClass('l-dialog-syos-hide-close-btn');
    } catch (e) {}
  },

  destroy: function destroy() {

    document.fire(SYOSEvents.DESTROY, this);

    this.resetMetaViewport();

    this.abortRequest(this.infoRequest);
    this.infoRequest = null;

    this.abortRequest(this.houseDataRequest);
    this.houseDataRequest = null;

    this.abortRequest(this.summaryRequest);
    this.summaryRequest = null;

    this.abortRequest(this.seatDataRequest);
    this.seatDataRequest = null;

    this.abortRequest(this.seatAvailRequest);
    this.seatAvailRequest = null;

    if (SYOSFloor.currFloor) {
      SYOSFloor.currFloor = null;
      document.fire(SYOSEvents.CURR_FLOOR);
    }

    this.docHandlers.invoke("stop");
    this.docHandlers = null;

    this.cart.destroy(); // should be called first clear cart
    this.cart = null;

    this.dateSwitch.destroy();
    this.dateSwitch = null;

    this.pricetypeSelector.destroy();
    this.pricetypeSelector = null;

    this.interstitialOverlay.destroy();
    this.interstitialOverlay = null;

    this.alertOverlay.destroy();
    this.alertOverlay = null;

    this.confirmOverlay.destroy();
    this.confirmOverlay = null;

    this.headerBar.destroy();
    this.headerBar = null;

    this.seatInfoDisplay.destroy();
    this.seatInfoDisplay = null;

    this.infoBar.destroy();
    this.infoBar = null;

    this.seatView.destroy();
    this.seatView = null;

    this.overviewDisplay.destroy();
    this.overviewDisplay = null;

    this.legend.destroy();
    this.legend = null;

    this.mobilePhotoPreviewSwitch.destroy();
    this.mobilePhotoPreviewSwitch = null;

    if (this.house) {
      this.house.destroy();
    }
    this.house = null;

    this.onSeatAvailRequestSuccess = null;

    SYOSMain.instance = null;
  }

});

SYOSMain.isBrowserSupported = SYOSMisc.checkBrowserCompatible();
SYOSMain.mobileMediaQuery = 'only all and (max-width: 739px)';

SYOSMain.testIsMobileView = function () {
  return window.matchMedia(SYOSMain.mobileMediaQuery).matches;
};

SYOSMain.shouldCloseDialog = function (confirmCallback) {
  if (SYOSMain.instance && !SYOSMain.instance.hasErrored && SYOSMain.instance.cart.getCurrentSeatIds()) {
    document.fire(SYOSEvents.CONFIRM_DIALOG_CLOSE, confirmCallback);
    return false;
  }
  return true;
};

SYOSMain.shouldCloseDialog_LDialog2 = function (shouldClose) {
  var syos = SYOSMain.instance;
  if (syos && !syos.hasErrored && syos.mode !== SYOSMode.SEAT_PREVIEW && syos.cart.getCurrentSeatIds()) {
    document.fire(SYOSEvents.CONFIRM_DIALOG_CLOSE, shouldClose);
  } else {
    shouldClose(true);
  }
};

export { SYOSAlert, SYOSCart$$1 as SYOSCart, SYOSCartSeat, SYOSCloseDialogWithUnreservedSeatsMode, SYOSConfirmOverlay, SYOSDateSwitch, SYOSErrorOverlay, SYOSErrors, SYOSEvents, SYOSFloor, SYOSHeaderBar, SYOSHouse, SYOSInfoBar, SYOSInterstitialOverlay, SYOSLegend, SYOSMain, SYOSMessage$$1 as SYOSMessage, SYOSMessageTemplates, SYOSMisc, SYOSMode, SYOSOverviewDisplay, SYOSPhotoPreviewOverlay, SYOSPhotoPreviewSwitch, SYOSPricetypeSelector$$1 as SYOSPricetypeSelector, SYOSSeat$$1 as SYOSSeat, SYOSSeatInfoDisplay$$1 as SYOSSeatInfoDisplay, SYOSSeatView$$1 as SYOSSeatView, SYOSZoomControl, DisplayTypes as SYOSSeatDisplayType, SYOSSeatIcons };export default SYOSMain;
//# sourceMappingURL=syos.es2015.js.map
